import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styles from "./smartepisodes.module.scss";
import { Dropdown, Menu, Modal, Tabs, Select, Button } from "antd";
import clipvideo from "../../../../styles/images/clipvideo.svg";
import store from "../../../../context/store/store";
import { saverecordlist, shareRedux } from "../../../../base/socketChatService/newChat";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import { RecordClipsDelete, VideoRecordDelete, copyLink, createClip, createPlayList, downloadFile, editMeetName, fetchClips, fetchPlayLists, finalShare, findRecHost, getDuration, searchHandler, searchHighlight, setRecClips, timeStampConverterMeeting, userStatusColor } from "../../../../base/callService/common";
import { bytesToSize, getCookie } from "../../../../base/utils";
import moment from "moment";
import { URChatLeftSkeleton } from "../../../../shared/skeletonLoading/chatLeftSkeleton";
import NoContent from "../../../../shared/widgets/noContent";
import noResult from "../../../../styles/images/empty_states/empty-nofound.svg";
import Lottie from "lottie-react";
import { storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import uservdoimg from "../../../../styles/images/cc img.svg";
import { Tooltip } from "antd";
import { UserDetails } from "../../../../models/model";
import groovyWalkAnimation from "../../../styles/images/chat blank state loading.json";
import { config } from "../../../../base/constant";
import axios from "axios";
import _ from "lodash";
import { Input } from 'antd';
import { URInput } from "../../../../shared/widgets/input";
import { contactReducer } from "../../../../context/reducer/contactReducer";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { useSelector } from "react-redux";
import MemberLists from "../../../call/callsWidgets/memberList";
import emptyimg from "../../../../styles/images/empty_states/empty-nofound.svg"
const { Option } = Select;

type recordstate ={
  allContacts: any;
  favouriteContacts: any;
  searchKey: string;
  shareUrl: any;
  shareContact: any;
  isShareModal:any;
  searchIcon:boolean;
  searchVal:string;
  shareCon:any;
  message:string;
  deleteRecordModal:boolean;
  tempfilteredContacts:any
  };


export default function SmartEpisodesScreen() {
  let {contactReducer }: any = useSelector((state: any) => state);
  let { workContacts, favContacts,shareDetails, teamContacs  } = contactReducer;
  const [recShareModal, setRecShareModal] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [recordlist, setRecordlist] = useState([]);
  const [smartModal, setSmartModal] = useState(false);
  const [highlightModal, setHighlightModal] = useState(false);
  const [clipModal, setClipModal] = useState(false);
  const [playlistModal, setPlaylistModal] = useState(false);
  const [confirmClipModal,setConfirmClipModal] = useState(false);
  const [confirmRecModal,setConfirmRecModal] = useState(false);
  const [recURL,setrecURL] = useState('');
  const [formatDur,setFormatDur]=useState(0);
  const [formatDurRec,setFormatDurRec]=useState(0);
  const [formatDurClip,setFormatDurClip]=useState(0);
  const [interval,setInterval]=useState(0);
  const [videoState,setVideoState]=useState("pause");
  const [videoStateClip,setVideoStateClip]=useState("pause");
  const [selectedClips,setSelectedClips]=useState([]);
  const [selectedRec,setSelectedRec]=useState([]);
  const [clipShareModal, setClipShareModal] = useState(false);
  const [clipDetailPage,setClipDetailPage]=useState({});
  let [currentIndex,setCurrentIndex]=useState(-1);
  const [recNameEditModal,setRecNameEditModal]=useState(false);
  const [recTitle,setRecTitle]=useState("");
  const [playListId,setPlayListId] = useState("");
  const [clipRecId,setClipRecId] = useState([]);
  const [shareButtonEnabled, setShareButtonEnabled] = useState(false);
  const [videoStateRec,setVideoStateRec] = useState("pause")
 
  let{recLoad,recordDetailPage,videoRecordingList,clips,playLists,planBased}=store.getState().meetingReducer;
  const { TabPane } = Tabs;
  const [getrecData, setRecData] = useState<recordstate>({
    allContacts: [], favouriteContacts: favContacts, searchKey: "", shareUrl: [], shareContact: [],
  isShareModal: false, message:"" ,tempfilteredContacts:[],
     searchIcon:false , searchVal: "", shareCon: [],deleteRecordModal:false
   });
  useEffect (()=>{
    let uniqueTeamContact: any = _.uniqBy(teamContacs, 'team_id');
    let allContactsList:any  =  [...workContacts, ...uniqueTeamContact]
    setRecData({...getrecData,allContacts : allContactsList,tempfilteredContacts:allContactsList})
    setRecordlist(videoRecordingList);
    if(videoRecordingList && videoRecordingList.length ===0){storeWindowState("meetingDetails")}else{recordinglist(videoRecordingList[0]);}
  },[videoRecordingList,JSON.stringify(clipDetailPage),clips?.length])

  const recordinglist = (record: any) => {
    saverecordlist(record);
  }
  const openClipShareModal = (clips?:any) =>{
    let arr:any=[];
    arr = [...selectedClips, clips]
    setSelectedClips(arr);
    setClipShareModal(true);
  }

  const openMultiShare=()=>{
    setClipShareModal(true);
  }
 const openMultiShareRec=()=>{
  setRecShareModal(true);
 }

  const closeClipShareModal = () =>{
    setClipShareModal(false);
    setSelectedClips([]);
    setRecData((prevData) => ({ ...prevData, shareCon: [] }));
  }

  const openRecShareModal=(data:any)=>{
    let arr:any=[];
    arr = [...selectedRec, data]
    setSelectedRec(arr);
    setRecShareModal(true);
  }

  const closeRecShareModal=()=>{
    setRecShareModal(false);
    setSelectedRec([])
  }

  const returnToDetailPage=()=>{
    storeWindowState('meetingDetails')
  }
  const openPlayListModal = (id?:any) =>{
    setPlaylistModal(true)
    setClipRecId(id)
  }
  const closePlayListModal = (type:any) =>{
    setPlaylistModal(false)
  }
  const openShareMainModal = (id?:any,type?:any) =>{
    let recId:any=id ? [id] : "";
    setSelectedRec(recId)
    setRecShareModal(true)
    // setClipRecId(id)
  }
  const closeShareMainModal = () =>{
    setRecShareModal(false)
  }
  const openConfirmClipModal = (id?:any,type?:any) =>{

    let clipId:any=id ? [id] : "";
   if(type){ if(type ==="record"){setSelectedRec(clipId)}else{setSelectedClips(clipId)}}
    setConfirmClipModal(true);
  }
  const closeConfirmClipModal = () =>{
    setConfirmClipModal(false);
    setSelectedClips([]);
  }
  const openConfirmRecModal = (id?:any,type?:any) =>{
    let recId:any=id ? [id] : "";
    if(type){if(type ==="record"){setSelectedRec(recId)}else{setSelectedClips(recId)}}
    setConfirmRecModal(true)
  }
  const closeConfirmRecModal = () =>{
    setConfirmRecModal(false)
    setSelectedRec([])
  }

  const deleteRecFiles=()=>{
    const id = selectedRec?.map((elem: any)=> elem.unique_id);
    VideoRecordDelete(id);
    closeConfirmRecModal();
    resetCheckBox("record");
  }

  const searchContact = (e: string) => {
    let searchName = e.toLowerCase();
    if (searchName !== "") {
        let contactList: any = (_.isEmpty(getrecData.allContacts) || getrecData.allContacts.length !== 0) ? getrecData.tempfilteredContacts : getrecData.allContacts;
        let filtered = _.filter(contactList, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      setRecData({ ...getrecData, allContacts: filtered, searchKey: searchName, favouriteContacts: favContacts });
    }
    else { setRecData({ ...getrecData, allContacts: getrecData.allContacts, searchKey: searchName, favouriteContacts: favContacts }); }
  };


  const menuai = (clips:any) => (
    <Menu>
    <Menu.Item onClick={()=>copyLink(clips)}>Link</Menu.Item>
    <Menu.Item onClick={()=>openClipShareModal(clips)}>Share</Menu.Item>
    {/* <Menu.Item onClick={()=>openPlayListModal(clips.clip_record_id)}>Add to playlist</Menu.Item> */}
    <Menu.Item onClick={()=> openConfirmClipModal(clips,"clips")}>Delete</Menu.Item>
  </Menu>
  );

  const RecIndMenuai = (rec:any) => (
    <Menu>
    <Menu.Item onClick={()=>copyLink(rec)}>Link</Menu.Item>
    <Menu.Item onClick={()=>openRecShareModal(rec)}>Share</Menu.Item>
    {/* <Menu.Item onClick={()=>openPlayListModal(clips.clip_record_id)}>Add to playlist</Menu.Item> */}
    <Menu.Item onClick={()=> openConfirmRecModal(rec,"record")}>Delete</Menu.Item>
  </Menu>
  );

  const recordmenuai = (record:any) => (
    <Menu>
    <Menu.Item onClick={()=>copyLink(record)}>Link</Menu.Item>
    {/* <Menu.Item onClick={()=>openRecShareModal(clips)}>Share</Menu.Item> */}
    {/* <Menu.Item onClick={()=>openPlayListModal(clips.clip_record_id)}>Add to playlist</Menu.Item> */}
    <Menu.Item  onClick={()=>downloadFile(recordDetailPage)} >Download</Menu.Item>
  </Menu>
  );

  const openModalSmart = () => {
    setSmartModal(true);
  };
  const closeModalSmart = () => {
    setSmartModal(false);
  };
  const openModalHighlights = (val:any,index:any) => {
    setHighlightModal(true);
    setClipDetailPage(val);
    setCurrentIndex(index);
  };
  const closeModalHighlights = () => {
    setHighlightModal(false);
  };
  const openModalClip = (url: string) => {
    setClipModal(true);
    setrecURL(url);
  };
  const closeModalClip = () => {
    setClipModal(false);
    const video = videoRef.current;
    video.pause();
    setVideoState("pause");
  };

  // const options = playLists.map((playlist:any) => ({
  //   value: playlist.playlist_id,
  //   label: playlist.playlist_name
  // }));

  const handleCancelClick = () => {
    closeModalClip();
  };

   
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const videoRefRec =  useRef<HTMLVideoElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const containerRef = useRef(null);
  const videoRefClip =  useRef<HTMLVideoElement | null>(null);
  const [frames, setFrames] = useState<string[]>([]);
  const [currentTime, setCurrentTime] = useState(0);
  const [currentTimeRec,setCurrentTimeRec] = useState(0)
  const [currentTimeClip,setCurrentTimeClip] = useState(0)
  const [trimStart, setTrimStart] = useState<number>(0);
  const [trimEnd, setTrimEnd] = useState<number>(0);
  const [isTrimmingStart, setIsTrimmingStart] = useState(false);
  const [isTrimmingEnd, setIsTrimmingEnd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDraggingBar, setIsDraggingBar] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);
  const loaderBarRef = useRef(null);
  const loaderBarRefClip = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isDraggingClip, setIsDraggingClip] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [clipsPlaylistBtn, setClipsPlaylistBtn] = useState(false)
  // const [videoState,setVideoState]=useState("pause");

  useEffect(() => {

     // {Clips And Playlist}
    const ClipsPlaylist = planBased.find((item:any) => item.featureid === 11);
    if (ClipsPlaylist && ClipsPlaylist.value1 === "Yes") {
      setClipsPlaylistBtn(false); 
    } else {
      setClipsPlaylistBtn(true);
    }
  
  }, [planBased]);

  useEffect(() => {
    console.log("clipModal>>",clipModal);
    const video = videoRef.current;
    const videoRec = videoRefRec.current
    const videoClip = videoRefClip.current;
    const canvas = canvasRef.current;
    let isCapturing = false; // Flag to prevent concurrent capture
    let count = 0;
    setIsLoading(false);
    const captureAllFrames = async () => {
      if (!video || !canvas) return;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const frameDataArray: any = [];
      const duration = Math.floor(video.duration); // Duration in seconds

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const interval = duration >= 10 ? duration / 10 : duration;
      setInterval(interval);
      const captureFrameAtTime = (time: number) => {
        console.log("capture frame calling>>>>");
        return new Promise<void>((resolve) => {
          const onSeeked = () => {
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const frameData = canvas.toDataURL("image/png");
            frameDataArray.push(frameData);
            video.removeEventListener("seeked", onSeeked);
            resolve();
          };
          video.addEventListener("seeked", onSeeked);
          count++;
          video.currentTime = count && count === 10 ? 0 : time;
        });
      };

      for (let i = 0; i <= 9; i += 1) {
        await captureFrameAtTime(i * interval);
      }

      setFrames(frameDataArray);
      if (frameDataArray.length === 10) {
        setIsLoading(true);
      }
      video.currentTime = 0;
    };

    const onLoadedMetadata = () => {
      let vdo: any = document.getElementById("vdo");
      if(!vdo) return;
      captureAllFrames();
      setFormatDur(vdo?.duration);
      setTrimEnd(vdo?.duration < 30 ? vdo?.duration : 30);
    };
    const onLoadedMetadataRec = () => {
      console.log("loaded meta data is calling rec")

      let vdoRec: any = document.getElementById("vdoRec");
      // captureAllFrames();
      setFormatDurRec(vdoRec?.duration);
      // setTrimEnd(vdo?.duration < 30 ? vdo?.duration : 30);
    };
    // const onLoadedMetadataClip = () => {
  
      // setTrimEnd(vdo?.duration < 30 ? vdo?.duration : 30);
    // };

    if (video) {
      video.load();
      video.addEventListener("loadeddata", onLoadedMetadata);
    }
    if (videoRec) {
      videoRec.addEventListener("loadeddata", onLoadedMetadataRec);
    }
    // if (videoClip) {
    //   videoClip.addEventListener("loadeddata", onLoadedMetadata);
    // }
    if (!clipModal) {
      setTitle("");
      setDescription("");
      setTrimStart(0);
      setTrimEnd(formatDur > 30 ? 30 : formatDur);
    }

    return () => {
      if (video) {
        video.removeEventListener("loadeddata", onLoadedMetadata);
      }
    };
  }, [recURL, clipModal,JSON.stringify(recordDetailPage.unique_id)]);


  useEffect(() => {
    const vdoClip = document.getElementById("vdoClip");

    const handleLoadedMetadata = () => {
      setFormatDurClip(vdoClip?.duration);
    };

    if (vdoClip) {
      vdoClip.addEventListener('loadedmetadata', handleLoadedMetadata);
    }

    // Cleanup the event listener when the component unmounts or highlightModal changes
    return () => {
      if (vdoClip) {
        vdoClip.removeEventListener('loadedmetadata', handleLoadedMetadata);
      }
    };
  }, [highlightModal]);

  useEffect(() => {
    const handleMouseMove = (e:any) => {
        if (isDragging) {
            updateProgress(e);
        }
    };

    const handleMouseUp = () => {
        if (isDragging) {
            setIsDragging(false);
        }
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
}, [isDragging]);
useEffect(() => {
  const handleMouseMoveClip = (e:any) => {
      if (isDraggingClip) {
          updateProgressClip(e);
      }
  };

  const handleMouseUpClip = () => {
      if (isDraggingClip) {
          setIsDraggingClip(false);
      }
  };

  document.addEventListener('mousemove', handleMouseMoveClip);
  document.addEventListener('mouseup', handleMouseUpClip);

  return () => {
      document.removeEventListener('mousemove', handleMouseMoveClip);
      document.removeEventListener('mouseup', handleMouseUpClip);
  };
}, [isDraggingClip]);
useEffect(() => {
  const handleMouseMove = (e:any) => {
      if (isDragging) {
          updateProgress(e);
      }
  };

  const handleMouseUp = () => {
      if (isDragging) {
          setIsDragging(false);
      }
  };

  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);

  return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
  };
}, [isDragging]);
  const handleMouseDown = (e:any) => {
    setIsDragging(true);
    updateProgress(e);
};
const handleMouseDownClip = (e:any) => {
  setIsDraggingClip(true);
  updateProgressClip(e);
};

const updateProgress = (e:any) => {
    const rect = loaderBarRef.current.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const newTime = (offsetX / rect.width) * videoRefRec.current?.duration;
    videoRefRec.current.currentTime = newTime;
};
const updateProgressClip = (e:any) => {
  const rect = loaderBarRefClip.current.getBoundingClientRect();
  const offsetX = e.clientX - rect.left;
  const newTime = (offsetX / rect.width) * videoRefClip.current?.duration;
  videoRefClip.current.currentTime = newTime;
};
  const formatDurationn = () => {
    const hours = Math.floor(formatDur / 3600);
    const minutes = Math.floor((formatDur % 3600) / 60);
    const remainingSeconds = Math.floor(formatDur % 60);

    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = remainingSeconds.toString().padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  };
  const formatDurationnRec = () => {
    const hours = Math.floor(formatDurRec / 3600);
    const minutes = Math.floor((formatDurRec % 3600) / 60);
    const remainingSeconds = Math.floor(formatDurRec % 60);

    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = remainingSeconds.toString().padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  };

  const formatDurationnClip = () => {
    const hours = Math.floor(formatDurClip / 3600);
    const minutes = Math.floor((formatDurClip % 3600) / 60);
    const remainingSeconds = Math.floor(formatDurClip % 60);

    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = remainingSeconds.toString().padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  };
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
        if (containerRef.current.requestFullscreen) {
            containerRef.current.requestFullscreen();
        } else if (containerRef.current.mozRequestFullScreen) { /* Firefox */
            containerRef.current.mozRequestFullScreen();
        } else if (containerRef.current.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            containerRef.current.webkitRequestFullscreen();
        } else if (containerRef.current.msRequestFullscreen) { /* IE/Edge */
            containerRef.current.msRequestFullscreen();
        }
    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE/Edge */
            document.msExitFullscreen();
        }
    }
};



  const handleVideoTimeUpdate = () => {
    setCurrentTime(videoRef.current?.currentTime || 0);
    const video = videoRef.current;

    if (!video) return;
    // video.currentTime = trimStart;
    if (video.currentTime >= trimEnd) {
      video.pause();
      setVideoState("pause");
      video.currentTime = trimStart;
    }
  };
  const handleVideoTimeUpdateRec = () => {
    setCurrentTimeRec(videoRefRec.current?.currentTime || 0);
    const videoRec = videoRefRec.current;

    if (!videoRec) return;
    // videoRec.currentTime = videoRec.duration;
    if (videoRec.currentTime >= videoRec.duration) {
      videoRec.pause();
      setVideoState("pause");
      videoRec.currentTime = 0;
    }
  };
  const handleVideoTimeUpdateClip = () => {
    setCurrentTimeClip(videoRefClip.current?.currentTime || 0);
    const videoClip = videoRefClip.current;
    if (!videoClip) return;
    // videoClip.currentTime = videoClip.duration;
    if (videoClip.currentTime >= videoClip.duration) {
      videoClip.pause();
      setVideoStateClip("pause");
      videoClip.currentTime = 0;
    }
  };


  const handleBarDragStart = (event:any) => {
    setIsDraggingBar(true);
    setDragOffset(event.clientX);
  };

  const handleDragStart = (position: "start" | "end") => {
    if (position === "start") {
      setIsTrimmingStart(true);
      const video = videoRef.current;
      if (!video) return;
      video.currentTime = trimStart;
    } else if (position === "end") {
      setIsTrimmingEnd(true);
    }

  };

  const handleDragMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (isTrimmingStart || isTrimmingEnd) {
      const video = videoRef.current;
      if (!video) return;
      const rect = event.currentTarget.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const percentage = offsetX / rect.width;
      // const newTime = percentage * video.duration;
      let newTime = (percentage * video.duration);
      if (isTrimmingStart) {
        let newTrimStart = newTime;
        setTrimStart(newTime);
        if (trimEnd - newTrimStart < 10) {
          newTrimStart = trimEnd - 10;
        }
  
        setTrimStart(Math.max(0, newTrimStart));
        if (newTime >= trimEnd) {
       
          setTrimEnd(newTime + 0.1); // Ensures trimEnd is always after trimStart
        }
      } else if (isTrimmingEnd) {
        setTrimEnd(newTime);
        let newTrimEnd = newTime;
      // Ensure minimum trimming range of 10 seconds
      if (newTrimEnd - trimStart < 10) {
        newTrimEnd = trimStart + 10;
      }
      setTrimEnd(Math.min(video.duration, newTrimEnd));
        if (newTime <= trimStart) {
          setTrimStart(newTime - 0.1); // Ensures trimStart is always before trimEnd
        }
      }
    }
    else if (isDraggingBar) {
      const deltaX = event.clientX - dragOffset;
      const rect = event.currentTarget.getBoundingClientRect();
      const percentage = deltaX / rect.width;
      const video = videoRef.current;
      if (!video) return;
      const deltaTime = percentage * video.duration;
      setTrimStart(prev => Math.max(0, prev + deltaTime));
      setTrimEnd(prev => Math.min(video.duration, prev + deltaTime));
      setDragOffset(event.clientX);
    }
  };

  const handleDragEnd = () => {
    setIsTrimmingStart(false);
    setIsTrimmingEnd(false);
    setIsDraggingBar(false);
    document.removeEventListener('mousemove', handleDragMove);
    document.removeEventListener('mouseup', handleDragEnd);
  };

  const formatTime = (seconds: number): string => {
    const date = new Date(0);
    date.setSeconds(seconds);
    return date.toISOString().substr(11, 8);
  };

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        setVideoState("play");
        videoRef.current.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      } else {
        setVideoState("pause");
        videoRef.current.pause();
      }
    }
  };
  const handlePlayPauseRec = () => {
    if (videoRefRec.current) {
      if (videoRefRec.current.paused) {
        setVideoStateRec("play");
        videoRefRec.current.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      } else {
        setVideoStateRec("pause");
        videoRefRec.current.pause();
      }
    }
  };
  const handlePlayPauseClip = () => {
    if (videoRefClip.current) {
      if (videoRefClip.current.paused) {
        setVideoStateClip("play");
        videoRefClip.current.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      } else {
        setVideoStateClip("pause");
        videoRefClip.current.pause();
      }
    }
  };

  const timeStringToSeconds = (timeString: any) => {
    const parts = timeString.split(":");
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const seconds = parseInt(parts[2], 10);

    return hours * 3600 + minutes * 60 + seconds;
  };

  const calculateDuration = (): number => {
    return trimEnd - trimStart;
  };

  const formatDuration = (durationInSeconds: number): string => {
    if (
      typeof durationInSeconds !== "number" ||
      durationInSeconds < 0 ||
      isNaN(durationInSeconds)
    ) {
      return "Invalid duration";
    }

    if (durationInSeconds < 60) {
      return `${durationInSeconds.toFixed(0)} Sec`;
    } else if (durationInSeconds < 3600) {
      const minutes = Math.floor(durationInSeconds / 60);
      const seconds = durationInSeconds % 60;
      return `${minutes} Min ${seconds.toFixed(0)} Sec`;
    } else {
      const hours = Math.floor(durationInSeconds / 3600);
      const minutes = Math.floor((durationInSeconds % 3600) / 60);
      const seconds = durationInSeconds % 60;
      return `${hours} Hr ${minutes} Min ${seconds.toFixed(0)} Sec`;
    }
  };

  const trimVdo = () => {
    let loggedUserDetails: UserDetails =
      store.getState().loginReducer.userdetails || [];
    let data: any = {
      id: recordDetailPage.v_id,
      meeting_id: recordDetailPage.meeting_id,
      title: title,
      description: description,
      startPoint: timeStringToSeconds(formatTime(trimStart)),
      endpoint: timeStringToSeconds(formatTime(trimEnd)),
      inputStream: recordDetailPage.record_url,
      ext: loggedUserDetails.ext,
      duration: calculateDurationInSec(),
      size: recordDetailPage.record_size
    };

    createClip(data);
    closeModalClip();
  };

  const calculateDurationInSec = () => {
    const startSeconds = timeStringToSeconds(formatTime(trimStart));
    const endSeconds = timeStringToSeconds(formatTime(trimEnd));
    const durationSeconds = endSeconds - startSeconds;

    return durationSeconds;
  };
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.currentTime = trimStart;
    }
  }, [trimStart, videoState]);

  useEffect(() => {
    fetchPlayLists();
  }, [selectedClips?.length,selectedRec?.length]);
  function formatTimeDate(seconds: any) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = remainingSeconds.toString().padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  const containerWidth = 307; // Width of the container in pixels
  const frameWidth = containerWidth / frames.length;

  const selectAllClip=()=>{
    let clipSelAll:any=document.getElementById("clipSelectAll");
    let select:any=document.querySelectorAll<HTMLInputElement>('input[type="checkbox"].checkbox-item-clip');
    let con:any=clipSelAll.checked ? true : false;
      select.forEach((checkbox:any) => {
     checkbox.checked = con;
      })
     if(con) setSelectedClips(clips);
     else setSelectedClips([]);
  }

  const selectClip=(ele:any)=>{
    let clipSelAll:any=document.getElementById("clipSelectAll");
    clipSelAll.checked = clipSelAll.checked? !clipSelAll.checked : clipSelAll.checked;
    let isElementPresent:any=selectedClips.findIndex((elem:any)=>elem.clip_record_id === ele.clip_record_id )
    if(isElementPresent > -1) {
      const updatedClips = [...selectedClips];
      updatedClips.splice(isElementPresent, 1);
      setSelectedClips(updatedClips);
    }
    else{
      let arr:any=[];
      arr=[...selectedClips,ele];
      setSelectedClips(arr);
    }
  };

  const resetCheckBox=(type:any)=>{
   if(type==="record"){ let recselAll:any=document.getElementById("recordSelectAll");
    recselAll.checked = false;
    let select:any=document.querySelectorAll<HTMLInputElement>('input[type="checkbox"].checkbox-item-record');
      select.forEach((checkbox:any) => {
     checkbox.checked = false;
      })}
      else{
        let clipSelAll:any=document.getElementById("clipSelectAll");
        if (clipSelAll) {
          clipSelAll.checked = false;
        }
        let select:any=document.querySelectorAll<HTMLInputElement>('input[type="checkbox"].checkbox-item-clip');
        select.forEach((checkbox:any) => {
          checkbox.checked = false;
           })
      }
  }

  const selectAllRecord=()=>{
    let recselAll:any=document.getElementById("recordSelectAll");
    let select:any=document.querySelectorAll<HTMLInputElement>('input[type="checkbox"].checkbox-item-record');
    let con:any=recselAll.checked ? true : false;
      select.forEach((checkbox:any) => {
     checkbox.checked = con;
      })
     if(con) setSelectedRec(recordlist);
     else setSelectedRec([]);
  }

  const selectRecord=(ele:any)=>{
    let recselAll:any=document.getElementById("recordSelectAll");
    recselAll.checked = recselAll.checked? !recselAll.checked : recselAll.checked;
    let isElementPresent:any=selectedRec.findIndex((elem:any)=>elem.unique_id === ele.unique_id )
    if(isElementPresent > -1) {
      const updatedRec:any = [...selectedRec];
      updatedRec.splice(isElementPresent, 1);
      setSelectedRec(updatedRec);
    }
    else{
      let arr:any=[];
      arr=[...selectedRec,ele];
      setSelectedRec(arr);
    }
  }

  const isTrimButtonEnabled = title.trim() !== '';

    const selectContact = (val: any, obj: any) => {
      var filtered_array = [];
      let workContactList: any = workContacts;
      var teammembersdetails: any = [];
      var arr: any = [];
      var checkVal: any;
      let teamList:any = contactReducer.teamContacs;
      try {
        for (var i = 0; i < obj.length; i++) {
          let data: any = JSON.parse(obj[i].key);
          checkVal = data;
         if(data.sip_login_id) {
            let item = {
              chattype:"one",
              sipid: data.sip_login_id,
              name: data.caller_id,
              ext: data.ext.toString(),
              profile_img: data.ImageURL,
              email: data.email_id,
              roletype: 3,
              user_type: "company"
            };
            filtered_array.push(item);         
          }
          else if (data.team_id) {
            let test = _.find(teamList,function(user:any){
              if(user.team_id === data.team_id)
              {
  
                let item = {
                  team_id: data.team_id.toString(),
                  name: data.team_name,
                  profile_img: data.profile_image_url,
                  roletype: 3,
                  user_type: "company",
                  chattype:"group"
                };
                arr.push(item)
              }
            })
          }
        };
        setRecData({ ...getrecData, shareContact: (filtered_array && arr ) ? filtered_array.concat(arr):(filtered_array && (!arr)) ?filtered_array :arr, shareCon: val ,allContacts : getrecData.tempfilteredContacts, searchKey: ""});
        let combinedArray = filtered_array.concat(arr);
        setShareButtonEnabled(combinedArray.length > 0);
      }
      catch (e: any) {
        console.log("selectBoxOnchange >>>>>", e)
      }
    }

    const handleTab=()=>{
         resetCheckBox("record");
         resetCheckBox("clips");
         setSelectedClips([]);
         setSelectedClips([]);
    }


    const movePrevious=()=>{
      if (currentIndex > 0) {
        const idxPrev:any=currentIndex-1;
        setCurrentIndex(idxPrev);
        setClipDetailPage(clips[idxPrev])
      } 
    }

    const moveNext=()=>{
      if (currentIndex < clips.length - 1) {
        const idxNext:any=currentIndex+1;
        setCurrentIndex(idxNext)
        setClipDetailPage(clips[idxNext])
      }
    }

    const editRecName=()=>{
        setRecNameEditModal(true);
    }



    const shareFile=(type:any)=>{
      const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
    
        let token: any = getCookie("ssoToken");
        var authkey = {
          "Content-Type": "application/json",
          Authorization: token
        };
    
       if(type === "clips"){selectedClips.forEach((ele:any)=>{
        fetch(ele?.clip_Url).then(response=>response.blob())
        .then(blob=>{
          const formData = new FormData();
          formData.append("doc", blob, ele?.meeting_name);
          axios
            .post(url, formData, { headers: authkey })
            .then((response: any) => {
              finalShare(response.data.files, getrecData.shareContact,ele?.meeting_name,getrecData.message);
              closeClipShareModal();
            })
        })
       }) }
       else{
        selectedRec.forEach((ele:any)=>{
          fetch(ele?.record_url).then(response=>response.blob())
          .then(blob=>{
            const formData = new FormData();
            formData.append("doc", blob, ele?.meeting_name);
            axios
              .post(url, formData, { headers: authkey })
              .then((response: any) => {
                finalShare(response.data.files, getrecData.shareContact,ele?.meeting_name,getrecData.message);
                closeRecShareModal();
                closeShareMainModal();
              })
          })
         })
       }
        setRecData({ ...getrecData, isShareModal: false ,shareContact: [], shareCon: [],message:""});
        resetCheckBox(type);
        setSelectedClips([]);
        setSelectedRec([]);
      }

    let resContact: any = searchHandler(getrecData.allContacts, getrecData.searchKey);
    let len = resContact?.length > 7 ?Math.round((resContact?.length / 8)) : 1;
    let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

    const closeRecEditModal=()=>{
      setRecNameEditModal(false)
    }

    const changeRecName=(e:any)=>{
      setRecTitle(e.target.value);
    }

    const recNameEdit=(type:any)=>{

      if(type === "cancel"){
        setRecNameEditModal(false);
        setRecTitle("")
      }
      else{
        editMeetName({meeting_name:recTitle,meeting_id:recordDetailPage.meeting_id,v_id:recordDetailPage.v_id})
        setRecTitle("")
        setRecNameEditModal(false);
      }

    }

  const deleteClips =() =>{
    const id = selectedClips?.map((elem: any)=> elem.clip_record_id);
    RecordClipsDelete(id);
    closeConfirmClipModal();
    resetCheckBox("clips");

  }


  const addClips = () =>{
    let loggedUserDetails: UserDetails =
    store.getState().loginReducer.userdetails || [];
    let data: any = {
      playlist_id:playListId?.playlist_id,
      playlist_name:playListId?.playlist_name,
      playlist_desc:playListId?.playlist_desc,
      clip_record_id:clipRecId
  
     
    };

    createPlayList(data);
    // closePlayListModal();
  }
  const handleChange = (e:any) => {

     let id = e;

    const integerValue = parseInt(id[0]);
     const specificPlaylist = playLists.find((playlist:any) => 
     {


       return playlist.playlist_id === integerValue;
     })
      setPlayListId(specificPlaylist)

  }
  const formatDate = (elem:any) => {
    const date = new Date(elem);

    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };


  // const loaderWidth = duration ? (currentTime / duration) * 100 : 0;
  

  return (
    <>
      <div className={`${styles.smartepisodes} ${styles.smartepisodebodyy}`}>
        <div className={styles.toparea} onClick={returnToDetailPage}>
          <button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="12"
              viewBox="0 0 6 12"
              fill="none"
            >
              <path
                d="M5.32945 0.907811L5.33011 0.908475C5.4268 1.00533 5.42747 1.16325 5.32884 1.26175C5.32882 1.26177 5.3288 1.26179 5.32878 1.26181L1.46434 5.11405C1.46432 5.11407 1.4643 5.11409 1.46427 5.11411C1.22723 5.35036 1.09707 5.66762 1.09707 6.00042C1.09707 6.33334 1.22795 6.64929 1.46425 6.88481C1.46428 6.88484 1.46431 6.88487 1.46434 6.8849L5.32892 10.7378C5.32893 10.7378 5.32895 10.7378 5.32897 10.7378C5.42753 10.8365 5.42676 10.9947 5.33011 11.0915L5.32921 11.0924C5.28079 11.1411 5.21797 11.1655 5.15277 11.1655C5.0886 11.1655 5.02491 11.1412 4.9755 11.0921C4.97547 11.0921 4.97545 11.0921 4.97543 11.0921L1.11141 7.23925C1.11138 7.23923 1.11136 7.23921 1.11133 7.23918C0.77962 6.90821 0.597559 6.47008 0.597169 6.00001C0.596779 5.53093 0.778438 5.09278 1.11158 4.75952C1.11166 4.75944 1.11174 4.75936 1.11182 4.75928L4.97642 0.907381C4.97642 0.907373 4.97643 0.907365 4.97644 0.907358C5.07432 0.809839 5.23254 0.810366 5.32945 0.907811Z"
                fill="#757676"
                stroke="#757676"
              />
            </svg>
            Back
          </button>
        </div>

        <div className={styles.mainarea}>
          <div className={styles.mainarealefts}>
            <div className={styles.videosection}>
              <div className={styles.videosectiontop}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                >
                  <path
                    d="M9.30846 7.3081V0H3.87366C2.21676 0 0.873657 1.3428 0.873657 3V7.3081H9.30846Z"
                    fill="white"
                  />
                  <path
                    d="M10.6915 7.3081H19.1263V3C19.1263 1.3428 17.7832 0 16.1263 0H10.6915V7.3081Z"
                    fill="white"
                  />
                  <path
                    d="M10.6915 8.6914V16H16.1263C17.7832 16 19.1263 14.6567 19.1263 13V8.6914H10.6915Z"
                    fill="white"
                  />
                  <path
                    d="M9.30846 8.6914H0.873657V13C0.873657 14.6567 2.21676 16 3.87366 16H9.30846V8.6914Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className={styles.videosectionmid} ref={containerRef}>
                {/*  Video Player place here */}
                <video
                  className="videoFluidone"
                  //  controls={true}
                  ref={videoRefRec}
                  id="vdoRec"
                  preload="metadata"
                  src={recordDetailPage?.record_url}
                  onTimeUpdate={handleVideoTimeUpdateRec}
                ></video>

                 <div className={styles.videocontrolscustom}>
                  <div className={styles.vdoconfrstcol}>
                    <div className={styles.pausesvgcon}  onClick={handlePlayPauseRec}>
                         {/* <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                         <path d="M8.33258 0.666748H7.33325C6.59687 0.666748 5.99992 1.2637 5.99992 2.00008V10.0001C5.99992 10.7365 6.59687 11.3334 7.33325 11.3334H8.33258C9.06896 11.3334 9.66592 10.7365 9.66592 10.0001V2.00008C9.66592 1.2637 9.06896 0.666748 8.33258 0.666748Z" fill="#F7F9FC"/>
                        <path d="M2.66658 0.666748H1.66732C0.930938 0.666748 0.333984 1.2637 0.333984 2.00008V10.0001C0.333984 10.7365 0.930938 11.3334 1.66732 11.3334H2.66658C3.40296 11.3334 3.99992 10.7365 3.99992 10.0001V2.00008C3.99992 1.2637 3.40296 0.666748 2.66658 0.666748Z" fill="#F7F9FC"/>
                         </svg> */}
                          {videoStateRec === "pause" ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="14"
                                viewBox="0 0 12 14"
                                fill="none"
                              >
                                <path
                                  d="M10.7805 5.34965L6.95047 3.14182L3.1204 0.933993C2.81178 0.759899 2.48733 0.672852 2.17079 0.672852C1.17371 0.672852 0.263672 1.4721 0.263672 2.57997V11.4192C0.263672 12.535 1.17371 13.3263 2.17079 13.3263C2.48733 13.3263 2.81178 13.2472 3.1204 13.0652L6.95047 10.8574L10.7805 8.64953C12.0546 7.91358 12.0546 6.07768 10.7805 5.34965Z"
                                  fill="#F7F9FC"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="10"
                                height="12"
                                viewBox="0 0 10 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.33258 0.666504H7.33325C6.59687 0.666504 5.99992 1.26346 5.99992 1.99984V9.99984C5.99992 10.7362 6.59687 11.3332 7.33325 11.3332H8.33258C9.06896 11.3332 9.66592 10.7362 9.66592 9.99984V1.99984C9.66592 1.26346 9.06896 0.666504 8.33258 0.666504Z"
                                  fill="#F7F9FC"
                                />
                                <path
                                  d="M2.66658 0.666504H1.66732C0.930938 0.666504 0.333984 1.26346 0.333984 1.99984V9.99984C0.333984 10.7362 0.930938 11.3332 1.66732 11.3332H2.66658C3.40296 11.3332 3.99992 10.7362 3.99992 9.99984V1.99984C3.99992 1.26346 3.40296 0.666504 2.66658 0.666504Z"
                                  fill="#F7F9FC"
                                />
                              </svg>
                            )}
                     </div>
                     {/* <div className={styles.speakersvgcon}>
                       <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                       <path d="M7.01126 0.984375C6.78192 0.984375 6.54746 1.06411 6.34932 1.24204L4.57266 2.83691C4.30279 3.07924 3.95292 3.21324 3.59026 3.21324H2.50879C1.40419 3.21324 0.508789 4.10878 0.508789 5.21324V6.78664C0.508789 7.89131 1.40419 8.78664 2.50879 8.78664H3.59026C3.95299 8.78664 4.30279 8.92057 4.57266 9.16297L6.34932 10.7578C6.54759 10.9359 6.78186 11.0156 7.01126 11.0156C7.52672 11.0156 8.01739 10.6123 8.01739 10.0137V1.98631C8.01739 1.38751 7.52686 0.984175 7.01126 0.984375ZM7.01726 10.0136L5.24072 8.41891C4.78672 8.01117 4.20052 7.78657 3.59019 7.78657H2.50872C1.95732 7.78657 1.50872 7.33798 1.50872 6.78657V5.21317C1.50872 4.66177 1.95732 4.21318 2.50872 4.21318H3.59019C4.20052 4.21318 4.78679 3.98857 5.24066 3.58104L7.01732 1.98678L7.01726 10.0136Z" fill="white"/>
                       <path d="M10.1919 3.53711C9.99499 3.34504 9.67859 3.34698 9.48492 3.54424C9.29159 3.74151 9.29479 4.05858 9.49206 4.25191C9.96439 4.71417 10.2258 5.33131 10.2287 5.98891C10.232 6.65164 9.97186 7.27797 9.49692 7.75131C9.30159 7.94664 9.30099 8.26304 9.49626 8.45831C9.59392 8.55664 9.72186 8.60544 9.85012 8.60544C9.97772 8.60544 10.1057 8.55664 10.2033 8.45957C10.8687 7.79551 11.2329 6.91657 11.2287 5.98431C11.2248 5.05724 10.8563 4.18878 10.1919 3.53711Z" fill="white"/>
                          <path d="M11.8631 2.13344C11.6659 1.94071 11.3495 1.94331 11.1561 2.14124C10.9628 2.33851 10.966 2.65491 11.1633 2.84824C12.0145 3.68157 12.4862 4.79417 12.4917 5.97977C12.4969 7.17444 12.0289 8.30204 11.1737 9.15491C10.9783 9.35024 10.9777 9.66664 11.1727 9.86191C11.2707 9.96024 11.3986 10.009 11.5268 10.009C11.6544 10.009 11.7823 9.96024 11.88 9.86318C12.9256 8.82018 13.4981 7.43937 13.4913 5.97517C13.4848 4.52011 12.9067 3.15624 11.8631 2.13344Z" fill="white"/>
                           </svg>
                     </div> */}

                   </div>
                  <div className={styles.vdoconscndcol}>
                     {/* <p>00:00:02 <span> / 02:30:17</span></p> */}
                     <p>
                              {formatTime(currentTimeRec)}/
                              <span>{formatDurationnRec()}</span>
                            </p>
                  </div>
                  <div className={styles.vdoconthrdcol}>
                        {/* <div className={styles.trimsvgcon}>
                             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                               <path d="M9.10796 6.74506C8.71396 6.74506 8.3481 6.85052 8.02143 7.02112L2.82396 0.711857C2.64816 0.497657 2.33276 0.467724 2.11983 0.643524C1.9069 0.819324 1.87636 1.13439 2.05176 1.34732L5.3523 5.35386L3.9787 7.02119C3.6521 6.85059 3.2863 6.74512 2.89236 6.74512C1.5873 6.74512 0.529297 7.80306 0.529297 9.10806C0.529297 10.4131 1.5873 11.471 2.89236 11.471C4.19743 11.471 5.25543 10.4131 5.25543 9.10806C5.25543 8.55986 5.06096 8.06152 4.74763 7.66046L6.00016 6.14026L7.2527 7.66079C6.93936 8.06152 6.74503 8.55986 6.74503 9.10806C6.74503 10.4131 7.80296 11.471 9.10803 11.471C10.4131 11.471 11.4711 10.4131 11.4711 9.10806C11.4711 7.80306 10.4131 6.74506 9.10796 6.74506ZM2.89236 10.471C2.14076 10.471 1.5293 9.85966 1.5293 9.10806C1.5293 8.35646 2.14076 7.74512 2.89236 7.74512C3.64396 7.74512 4.25543 8.35646 4.25543 9.10806C4.25543 9.85966 3.64396 10.471 2.89236 10.471ZM9.10796 10.471C8.35643 10.471 7.74496 9.85966 7.74496 9.10806C7.74496 8.35646 8.35643 7.74512 9.10796 7.74512C9.8595 7.74512 10.471 8.35646 10.471 9.10806C10.471 9.85966 9.85956 10.471 9.10796 10.471Z" fill="white"/>
                             <path d="M9.94863 1.34726C10.1241 1.13439 10.0935 0.819257 9.88056 0.643457C9.66736 0.467057 9.35223 0.49759 9.17643 0.71179L6.5057 3.95366L7.1535 4.74012L9.94863 1.34726Z" fill="white"/>
                           </svg>
                        </div>
                        <div className={styles.frwrdcon}>
                           <p>1x</p>
                         </div> */}
                        <div className={styles.fullscreensvgcon} onClick={toggleFullScreen}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                                <path d="M12.471 11.313H9.66016C9.38409 11.313 9.16016 11.0891 9.16016 10.813C9.16016 10.5369 9.38409 10.313 9.66016 10.313H12.471C12.5628 10.313 12.6377 10.2381 12.6377 10.1463V7.33773C12.6377 7.06166 12.8616 6.83773 13.1377 6.83773C13.4138 6.83773 13.6377 7.06166 13.6377 7.33773V10.1463C13.6377 10.7895 13.1142 11.313 12.471 11.313Z" fill="#F7F9FC"/>
                               <path d="M13.1377 5.16657C12.8616 5.16657 12.6377 4.94263 12.6377 4.66657V1.85343C12.6377 1.76163 12.5628 1.68677 12.471 1.68677H9.66048C9.38442 1.68677 9.16048 1.46283 9.16048 1.18677C9.16048 0.910701 9.38442 0.686768 9.66048 0.686768H12.471C13.1142 0.686768 13.6377 1.21023 13.6377 1.85343V4.66657C13.6377 4.94263 13.4137 5.16657 13.1377 5.16657Z" fill="#F7F9FC"/>
                            <path d="M4.33984 11.313H1.52897C0.885771 11.313 0.362305 10.7895 0.362305 10.1463V7.33773C0.362305 7.06166 0.586238 6.83773 0.862305 6.83773C1.13837 6.83773 1.3623 7.06166 1.3623 7.33773V10.1463C1.3623 10.2381 1.43717 10.313 1.52897 10.313H4.33984C4.6159 10.313 4.83984 10.5369 4.83984 10.813C4.83984 11.0891 4.6159 11.313 4.33984 11.313Z" fill="#F7F9FC"/>
                                  <path d="M0.862305 5.16657C0.586238 5.16657 0.362305 4.94263 0.362305 4.66657V1.85343C0.362305 1.21023 0.885771 0.686768 1.52897 0.686768H4.3395C4.61557 0.686768 4.8395 0.910701 4.8395 1.18677C4.8395 1.46283 4.61557 1.68677 4.3395 1.68677H1.52897C1.43717 1.68677 1.3623 1.76163 1.3623 1.85343V4.66657C1.3623 4.94263 1.13837 5.16657 0.862305 5.16657Z" fill="#F7F9FC"/>
                            </svg>
                        </div>
                  </div>
                   <div className={styles.loaderbar}
                             ref={loaderBarRef}
                             onMouseDown={handleMouseDown}
                        >
                          <div  className={styles.progressbar} 
                                 style={{ width: `${(videoRefRec.current?.currentTime / videoRefRec.current?.duration) * 100}%` }}>

                          </div>
                           <div className={styles.loaderindicator}
                                 style={{ left: `${(videoRefRec.current?.currentTime / videoRefRec.current?.duration) * 100}%` 
                                          //
                                          }}
                                         // onClick={()=>handleDragStartRec(start)}
                                         ></div>
         
                    </div>
                </div>  
              </div>
              <div className={`${styles.videosectionbottom} ${clipsPlaylistBtn ? 'disabledIcon':''}`}>
                <p>
                  {clips && clips?.length >0 ?  `` : `No Clips found in recording.`}
                  <span
                    onClick={() => openModalClip(recordDetailPage?.record_url)}
                  >
                    Create Clips
                  </span>
                </p>
              </div>
            </div>

            <div className={styles.videodetailsection}>
              <div className={styles.videodetailsectiontop}>
                <div className={styles.videodetailsectiontopleft}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="16"
                    viewBox="0 0 20 16"
                    fill="none"
                  >
                    <path
                      d="M18.8372 3.14233C18.6447 3.14233 18.4473 3.19671 18.261 3.31606L14.8807 5.48168V10.5183L18.261 12.6838C18.4473 12.8031 18.6449 12.8577 18.8374 12.8577C19.4413 12.8577 19.9953 12.3218 19.9953 11.5728V4.42731C19.9953 3.67851 19.4411 3.14233 18.8372 3.14233Z"
                      fill="#DE003D"
                    />
                    <path
                      d="M14.3244 6.19579C14.2963 4.74128 14.3056 2.90033 13.1806 1.77718C12.0927 0.691125 10.5082 0.534689 9.01723 0.497804C8.33271 0.479411 7.74876 0.470215 7.1647 0.470215C6.58064 0.470215 5.99669 0.479411 5.31217 0.497804C3.83059 0.534689 2.23655 0.691125 1.14891 1.77718C0.0236748 2.90952 0.0330711 4.75047 0.00488281 6.20498V9.80422C0.0330711 11.2587 0.0236748 13.0997 1.14891 14.2227C2.23655 15.3088 3.82129 15.4654 5.31217 15.5021C5.99669 15.5205 6.58064 15.5298 7.1647 15.5298C7.74876 15.5298 8.33271 15.5205 9.01723 15.5021C10.4987 15.4654 12.0927 15.3088 13.1806 14.2227C14.3056 13.0997 14.2964 11.2587 14.3244 9.80422C14.3339 9.20587 14.3432 8.59831 14.3339 8.00005C14.3339 7.4018 14.3339 6.80334 14.3244 6.19579ZM9.45794 8.6169L6.59654 10.269C6.12163 10.5432 5.52808 10.2006 5.52808 9.65218V6.34803C5.52808 5.79975 6.12163 5.45699 6.59654 5.73118L9.45794 7.3833C9.93275 7.65749 9.93275 8.34271 9.45794 8.6169Z"
                      fill="#DE003D"
                    />
                  </svg>
                  {recordDetailPage?.meeting_name}
                  <span onClick={editRecName}>Edit</span>
                </div>
                <div className={styles.videodetailsectiontopright}>
                  <ul>
                    {/* <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="16"
                        viewBox="0 0 20 16"
                        fill="none"
                      >
                        <path
                          d="M8.35671 5.53492H5.89171C5.43981 5.53492 5.07001 5.90452 5.07001 6.35672V9.64332C5.07001 10.0954 5.43981 10.4651 5.89171 10.4651H8.35671C8.80861 10.4651 9.17841 10.0955 9.17841 9.64332V9.23272C9.17841 9.00272 8.99771 8.82162 8.76761 8.82162H8.35681C8.12681 8.82162 7.94601 9.00282 7.94601 9.23272H6.30261V6.76742H7.94601C7.94601 6.99792 8.12681 7.17852 8.35681 7.17852H8.76761C8.99771 7.17852 9.17841 6.99782 9.17841 6.76742V6.35682C9.17841 5.90512 8.80861 5.53492 8.35671 5.53492Z"
                          fill="#3E3F40"
                        />
                        <path
                          d="M14.1084 5.53492H11.6434C11.1915 5.53492 10.8217 5.90452 10.8217 6.35672V9.64332C10.8217 10.0954 11.1915 10.4651 11.6434 10.4651H14.1084C14.5604 10.4651 14.9301 10.0955 14.9301 9.64332V9.23272C14.9301 9.00272 14.7493 8.82162 14.5193 8.82162H14.1084C13.8784 8.82162 13.6976 9.00282 13.6976 9.23272H12.0543V6.76742H13.6976C13.6976 6.99792 13.8784 7.17852 14.1084 7.17852H14.5193C14.7493 7.17852 14.9301 6.99782 14.9301 6.76742V6.35682C14.9301 5.90512 14.5603 5.53492 14.1084 5.53492Z"
                          fill="#3E3F40"
                        />
                        <path
                          d="M19.0992 6.16332C19.0634 4.68282 19.0753 2.80882 17.6441 1.66572C16.2604 0.559717 14.2446 0.400617 12.348 0.363017C11.4772 0.344417 10.7344 0.334717 9.99151 0.334717C9.24861 0.334717 8.50581 0.344517 7.63511 0.363017C5.75051 0.400617 3.72271 0.559817 2.33911 1.66572C0.907811 2.81802 0.919711 4.69212 0.883911 6.17252V9.83662C0.919711 11.3171 0.907811 13.1911 2.33911 14.3346C3.72271 15.4401 5.73851 15.5992 7.63511 15.6368C8.50581 15.6558 9.24871 15.6651 9.99151 15.6651C10.7343 15.6651 11.4772 15.6558 12.348 15.6368C14.2326 15.5992 16.2604 15.44 17.6441 14.3346C19.0753 13.191 19.0634 11.317 19.0992 9.83662C19.1112 9.22772 19.1231 8.60912 19.1112 8.00022C19.1112 7.39082 19.1112 6.78192 19.0992 6.16332ZM17.5996 9.80052L17.5957 9.96992C17.562 11.4509 17.4786 12.547 16.7078 13.1628C15.7072 13.9621 14.0067 14.1037 12.3156 14.1374C11.4568 14.156 10.7242 14.1652 9.99151 14.1652C9.25881 14.1652 8.52621 14.1559 7.66481 14.1374C5.97661 14.1037 4.27631 13.9626 3.27531 13.1628C2.50441 12.5471 2.42101 11.4509 2.38731 9.96992L2.38381 9.83662L2.38341 6.20872L2.38731 6.03932C2.42111 4.55592 2.50481 3.45822 3.27561 2.83762C4.27601 2.03782 5.97641 1.89622 7.66741 1.86252C8.52621 1.84392 9.25881 1.83472 9.99151 1.83472C10.7242 1.83472 11.4568 1.84402 12.3183 1.86252C14.0065 1.89622 15.7066 2.03732 16.708 2.83762C17.4786 3.45332 17.562 4.54902 17.5957 6.03002L17.5995 6.19262C17.6113 6.80152 17.6112 7.40062 17.6115 8.02952C17.6229 8.61892 17.611 9.22292 17.5996 9.80052Z"
                          fill="#3E3F40"
                        />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="4"
                        viewBox="0 0 8 4"
                        fill="none"
                      >
                        <path
                          d="M4.0001 3.93495C3.59843 3.93495 3.22143 3.77869 2.9379 3.49422L0.368898 0.918019C0.173898 0.722685 0.174565 0.406286 0.369898 0.211019C0.565832 0.0163527 0.882565 0.0163526 1.07723 0.212353L3.6459 2.78855C3.83503 2.97735 4.16543 2.97735 4.3539 2.78855L6.9229 0.212353C7.11756 0.0164193 7.4343 0.0164194 7.63023 0.211019C7.82557 0.406353 7.82616 0.722752 7.63123 0.918019L5.06223 3.49422C4.7787 3.77875 4.4015 3.93495 4.0001 3.93495Z"
                          fill="#3E3F40"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="22"
                        viewBox="0 0 18 22"
                        fill="none"
                      >
                        <path
                          d="M16.5128 3.23123C15.8193 2.23543 14.813 1.36333 13.5213 0.912434C13.1301 0.775934 12.7025 0.982534 12.5662 1.37363C12.4298 1.76473 12.6364 2.19243 13.0276 2.32893C13.9732 2.65803 14.7396 3.31013 15.2819 4.08873C15.8246 4.86363 16.1269 5.76283 16.1611 6.48693C16.182 6.90053 16.5343 7.21883 16.948 7.19813C17.3617 7.17713 17.6801 6.82483 17.6592 6.41123C17.6028 5.35583 17.206 4.23073 16.5128 3.23123Z"
                          fill="#3E3F40"
                        />
                        <path
                          d="M12.2462 3.23103C11.8578 3.08653 11.426 3.28423 11.2817 3.67273C11.1373 4.06093 11.335 4.49283 11.7234 4.63733C12.2583 4.83553 12.6947 5.21963 13.0029 5.68203C13.3116 6.14073 13.4759 6.67543 13.4853 7.07653C13.4977 7.49033 13.8434 7.81603 14.2575 7.80363C14.6715 7.79113 14.9971 7.44543 14.9847 7.03163C14.9598 6.29923 14.7056 5.53673 14.2511 4.85023C13.7961 4.16733 13.1246 3.55843 12.2462 3.23103Z"
                          fill="#3E3F40"
                        />
                        <path
                          d="M6.28597 4.34873C3.00177 4.34923 0.340366 7.01063 0.339966 10.2947C0.339966 10.7088 0.675666 11.0447 1.08997 11.0447C1.50427 11.0447 1.83997 10.7088 1.83997 10.2947C1.84047 9.06453 2.33647 7.95783 3.14207 7.15073C3.94907 6.34503 5.05587 5.84893 6.28597 5.84853C7.62677 5.85073 8.70627 6.41423 9.48227 7.23813C10.2564 8.05993 10.6871 9.14833 10.6831 10.0823L10.6747 10.3115C10.6299 10.9873 10.3839 12.0454 9.88687 12.7446C9.55307 13.2246 9.24567 13.5991 9.03667 13.8037C8.99447 13.8435 8.93087 13.9028 8.85797 13.9709L8.85567 13.9721C8.84167 13.986 8.69477 14.1105 8.48227 14.3217C8.47287 14.3305 8.45747 14.3449 8.45197 14.35C8.44837 14.3534 8.44727 14.3581 8.44377 14.3615C7.86467 14.9443 6.82007 16.1686 6.29547 17.9289L6.29097 17.9448C6.28767 17.9641 6.13927 18.4585 5.84057 18.8855C5.69267 19.0999 5.51167 19.2935 5.31387 19.4229C5.11357 19.5523 4.90677 19.628 4.62517 19.6299C4.54047 19.6297 4.44927 19.6223 4.34987 19.605L4.34057 19.6035C4.34057 19.6035 4.28877 19.5945 4.19167 19.5583C3.90007 19.445 3.23437 19.1186 2.59587 18.0346C2.38667 17.6769 1.92727 17.5566 1.56987 17.7658C1.21247 17.975 1.09187 18.4343 1.30107 18.7919C1.87477 19.7755 2.54177 20.3576 3.08477 20.6808C3.59897 20.9884 3.98487 21.0651 4.09187 21.0819C4.09477 21.0824 4.09747 21.0828 4.10057 21.0833C4.10407 21.0838 4.11437 21.0862 4.11717 21.0865L4.11737 21.0848C4.29097 21.1136 4.46127 21.1297 4.62517 21.1295C5.23157 21.1317 5.76717 20.932 6.17777 20.6495C6.79717 20.223 7.16587 19.6466 7.40107 19.1873C7.62167 18.7508 7.71667 18.4158 7.73477 18.3509C8.02167 17.3699 8.54677 16.5506 9.00257 15.984C9.19957 15.7386 9.37497 15.5514 9.51707 15.4081C9.55517 15.3722 9.60857 15.3224 9.67787 15.2575C9.81817 15.1264 9.99167 14.9645 10.0711 14.8903L10.084 14.8778C10.4019 14.5646 10.7446 14.1359 11.1174 13.6024C11.8445 12.5465 12.1001 11.2999 12.1708 10.4208C12.1789 10.3078 12.1831 10.1955 12.1831 10.0822C12.1791 8.70963 11.5966 7.30613 10.5773 6.21283C9.55987 5.12153 8.06577 4.34653 6.28597 4.34873Z"
                          fill="#3E3F40"
                        />
                        <path
                          d="M7.18457 10.8267C6.94397 11.1639 7.02237 11.6321 7.35967 11.8728C7.69687 12.1133 8.16527 12.0349 8.40587 11.6978C8.51577 11.5435 8.65957 11.3152 8.78117 11.0181C8.95067 10.5992 9.00277 10.19 9.00357 9.83943C9.00357 9.69023 8.99377 9.55133 8.97597 9.42193C8.88727 8.82813 8.57737 8.28233 8.10967 7.83403C7.64287 7.39163 6.98027 7.05353 6.20227 7.05353C6.04677 7.05333 5.88787 7.06693 5.72757 7.09523C4.35137 7.33813 3.38257 8.53203 3.38277 9.88623C3.38267 10.0498 3.39707 10.2151 3.42597 10.3799C3.49747 10.7879 3.88627 11.0606 4.29437 10.989C4.70237 10.9172 4.97507 10.5286 4.90347 10.1206L4.88257 9.88633C4.88267 9.25203 5.33927 8.68463 5.98757 8.57263L6.20217 8.55333C6.53577 8.55333 6.83577 8.69643 7.08017 8.92513C7.32347 9.14783 7.47317 9.46253 7.49017 9.62823L7.50357 9.83943C7.50447 10.032 7.46967 10.2644 7.39247 10.451C7.32607 10.6134 7.24687 10.7391 7.18457 10.8267Z"
                          fill="#3E3F40"
                        />
                      </svg>
                    </li> */}
                    <li onClick={()=>openShareMainModal(recordDetailPage)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M16.2668 4.58934L15.5686 3.91844C14.1165 2.52394 13.1765 1.64504 12.3733 1.21234C11.617 0.806135 10.7747 0.820735 10.0593 1.25143C9.65347 1.49753 9.36977 1.88324 9.18917 2.43694C9.05537 2.86274 8.98267 3.39594 8.94797 4.23384C4.92157 4.37344 0.0368652 5.35594 0.0368652 10.8734C0.0368652 13.6546 2.14237 16.225 4.09107 17.0121C4.20777 17.059 4.33037 17.0824 4.45147 17.0824C4.69557 17.0824 4.93487 16.9886 5.11557 16.8129C5.38607 16.5492 5.47497 16.1498 5.34216 15.7953C4.54727 13.6723 4.43347 12.2367 4.99357 11.4066C5.52287 10.6224 6.79047 10.1918 8.95747 10.0658C8.99217 10.934 9.07217 11.5736 9.26847 12.0785C9.47886 12.6234 9.89637 13.0394 10.4438 13.2514C11.0361 13.4799 11.7128 13.4438 12.2934 13.1537C13.1332 12.7435 14.0849 11.8344 15.5776 10.4076L16.2793 9.73384C17.2822 8.76994 17.8345 8.23874 17.9414 7.46134C17.9702 7.26214 17.9702 7.05314 17.9424 6.86174C17.835 6.07954 17.2859 5.55814 16.2668 4.58934ZM16.4558 7.25144C16.4192 7.51904 15.9499 7.97023 15.237 8.65473L14.488 9.37354C13.1975 10.6069 12.2653 11.4985 11.6286 11.809C11.4211 11.9125 11.1813 11.9272 10.9846 11.8529C10.8323 11.7933 10.7253 11.6879 10.6667 11.5355C10.4987 11.1039 10.4533 10.3197 10.4367 9.27384C10.4333 9.07364 10.3503 8.88324 10.2062 8.74454C10.0617 8.60684 9.86236 8.52183 9.66807 8.53553C6.42687 8.61663 4.65737 9.22403 3.75007 10.5677C3.05817 11.5921 2.95907 12.97 3.45707 14.8402C2.41117 13.8959 1.53667 12.3744 1.53667 10.8734C1.53667 7.30023 3.87947 5.80413 9.61967 5.71813C9.83496 5.73374 10.0582 5.65663 10.2169 5.49743C10.3844 5.33043 10.4601 5.09704 10.4303 4.86954L10.4362 4.59804C10.4528 4.02184 10.488 3.30604 10.6174 2.89494C10.7102 2.61074 10.8069 2.55213 10.8352 2.53454C11.0945 2.37833 11.3738 2.37924 11.6633 2.53354C12.2956 2.87434 13.2087 3.73174 14.5295 5.00034L15.2566 5.69853C15.9573 6.36453 16.4202 6.80404 16.4568 7.07154C16.4651 7.12624 16.4651 7.18994 16.4558 7.25144Z"
                          fill="#3E3F40"
                        />
                      </svg>
                    </li>
                    <li>
                    
                       <Dropdown overlay={recordmenuai(recordDetailPage)}>
                             
                              <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="18"
                        viewBox="0 0 6 18"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.99997 4.51288C4.23387 4.51288 5.24347 3.50328 5.24347 2.26938C5.24347 1.03548 4.23387 0.0258789 2.99997 0.0258789C1.76607 0.0258789 0.75647 1.03548 0.75647 2.26938C0.75647 3.50328 1.76607 4.51288 2.99997 4.51288ZM2.99997 6.75638C1.76607 6.75638 0.75647 7.76598 0.75647 8.99988C0.75647 10.2338 1.76607 11.2434 2.99997 11.2434C4.23387 11.2434 5.24347 10.2338 5.24347 8.99988C5.24347 7.76598 4.23387 6.75638 2.99997 6.75638ZM0.75647 15.7304C0.75647 14.4965 1.76607 13.4869 2.99997 13.4869C4.23387 13.4869 5.24347 14.4965 5.24347 15.7304C5.24347 16.9643 4.23387 17.9739 2.99997 17.9739C1.76607 17.9739 0.75647 16.9643 0.75647 15.7304Z"
                          fill="#3E3F40"
                        />
                      </svg>
                            </Dropdown>
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.videodesccon}>
                 {/* <p className={styles.videodesc}>Shared screen with active speaker view</p> */}
              </div>
              {/* <p className={styles.videodesc}>Shared screen with active speaker view</p> */}
              <div className={styles.videodetailsnumbers}>
                <p>
                  Host -{" "}
                  <span>
                    {findRecHost(
                      JSON.parse(recordDetailPage?.urmeet_user_list)
                    )}
                  </span>
                </p>
                <p>
                  Meeting ID - <span>{recordDetailPage?.meeting_id}</span>
                </p>
                <p>
                  Duration & Size -{" "}
                  <span>{`${getDuration(
                    recordDetailPage?.duration
                  )} • ${bytesToSize(recordDetailPage?.record_size)}`}</span>
                </p>
              </div>
            </div>
            <Modal
              centered
              visible={smartModal}
              title="Smart Episodes"
              onCancel={closeModalSmart}
              className="Performancemodal"
            >
              <div>
                <div className={styles.ppmetricssectionn}></div>
              </div>
            </Modal>
            <Modal
              centered
              visible={confirmClipModal}
              title={selectedRec.length > 1 ? `Delete Records` : `Delete record`}
              onCancel={closeConfirmClipModal}
                className="cv modallnewst reacreateclipmodal"
              footer={[
                <>
                  <Button key="Cancel" className="ShareClipscancel " onClick={closeConfirmClipModal}>Cancel</Button>
                  <Button key="OK" className="ShareClipsbtn  multideleteclipbtn"  onClick={deleteClips}>Delete</Button>
                </>
              ]}
            >
              <div>
                <div className={`${styles.ppmetricssectionn} ${styles.deleteClipsnewwbosy}`}>
                  <p>{"Are you sure you want to delete ? Once deleted, you'll need to recreate the clip."}</p>
                </div>
              </div>
            </Modal>
            <Modal
              centered
              visible={confirmRecModal}
              title={selectedRec.length > 1 ? `Delete Records` : `Delete record`}
              onCancel={closeConfirmRecModal}
                className="cv modallnewst reacreateclipmodal"
              footer={[
                <>
                  <Button key="Cancel" className="ShareClipscancel " onClick={closeConfirmRecModal}>Cancel</Button>
                  <Button key="OK" className="ShareClipsbtn  multideleteclipbtn"  onClick={deleteRecFiles}>Delete</Button>
                </>
              ]}
            >
              <div>
                <div className={`${styles.ppmetricssectionn} ${styles.deleteClipsnewwbosy}`}>
                  <p>{"Are you sure you want to delete ?"}</p>
                </div>
              </div>
            </Modal>

            <Modal
              centered
              visible={recNameEditModal}
              title="Edit Recording title"
              onCancel={closeRecEditModal}
               className="cv modallnewst clipShare"
              footer={[
                <>
                  <Button key="Cancel" className="ShareClipscancel" onClick={()=>recNameEdit("cancel")}>Cancel</Button>
                  <Button key="OK" className="ShareClipsbtn"  onClick={()=>recNameEdit("edit")}>OK</Button>
                </>
              ]}
            >
              <div>
                <div className={`${styles.ppmetricssectionn} ${styles.recordtitlebodyy}`}>
                  <URInput placeHolder="Title Name" className={`customFocused `} onChange={(e:any)=>changeRecName(e)} value={recTitle} />
                 
                </div>
              </div>
            </Modal>

            <Modal
              centered
              visible={highlightModal}
              title="Clips"
              onCancel={closeModalHighlights}
              footer={[
                <>
                  {currentIndex !== 0 && <Button key="Previous" className="ShareClipscancel" onClick={movePrevious} >Previous</Button>}
                  {currentIndex < clips?.length - 1 && <Button key="Next" className="ShareClipsbtn"  onClick={moveNext}>Next</Button> }
                </>
              ]}
              className="clipShare"
            >
                <div className={styles.paddingtoppcreateclip}>
                <div className={styles.ppmetricssectionn}>
                   <div className={styles.clipsheadlayer}>
                    <label>
                      {`Title Name : ${clipDetailPage?.title}`}
                    </label>
                    <div className={styles.svgflexcontainer}>
                      <div onClick={()=>copyLink(clipDetailPage)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                       <path d="M7.48696 9.07563L6.60029 9.94647C6.69529 10.1681 6.75071 10.3819 6.75863 10.5877C6.78238 11.0944 6.53696 11.4269 6.06196 11.8861C6.03029 11.9098 6.00654 11.9415 5.98279 11.9731L5.12779 12.8044C4.65279 13.2794 4.30446 13.509 3.79779 13.4852C2.67363 13.4061 1.23279 11.9415 1.19321 10.8331C1.16946 10.3106 1.39904 10.0019 1.91363 9.49522C1.97696 9.43188 2.36488 9.0598 2.61029 8.81438L2.84779 8.5848C3.27529 8.1573 3.60779 7.9198 4.06696 7.9198H4.15404C4.32821 7.93563 4.51029 7.97522 4.69237 8.05438L5.58696 7.17563C5.15154 6.9223 4.68446 6.77188 4.23321 6.74022C3.08529 6.66105 2.38862 7.36563 2.00863 7.74563L1.78696 7.9673C1.50196 8.24438 1.06654 8.66397 1.06654 8.67188C0.528208 9.18647 -0.0417918 9.82772 0.00570817 10.8806C0.0769582 12.5986 1.98488 14.5461 3.71863 14.6648C3.77404 14.6727 3.82946 14.6727 3.88487 14.6727C4.92987 14.6727 5.59488 14.0156 5.95904 13.6594L6.89321 12.749C6.89321 12.749 6.94863 12.6856 6.97237 12.654C7.47904 12.1552 7.98571 11.5298 7.94613 10.5323C7.93029 10.0494 7.76404 9.55063 7.48696 9.07563Z" fill="#757676"/>
                        <path d="M10.2895 0.834385C9.14154 0.747301 8.43696 1.46772 8.06488 1.8398L7.91446 1.9823C7.64529 2.25147 7.12279 2.76605 7.11488 2.77397C6.58446 3.28855 6.01446 3.92188 6.06196 4.9748C6.07779 5.41813 6.22029 5.88522 6.45779 6.32855L7.36029 5.4498C7.28904 5.27564 7.24946 5.09355 7.24154 4.9273C7.22571 4.41272 7.46321 4.08813 7.96988 3.5973C8.04113 3.52605 8.50029 3.0748 8.74571 2.8373L8.90404 2.68688C9.33154 2.25938 9.65613 2.01397 10.1232 2.01397C10.147 2.01397 10.1786 2.02188 10.2103 2.02188C11.3345 2.10105 12.7674 3.56563 12.8149 4.68188C12.8307 5.19647 12.6011 5.51313 12.1182 5.98022C12.0865 6.01189 12.0628 6.04355 12.039 6.07522L11.184 6.90647C10.7011 7.38147 10.3607 7.60313 9.85404 7.57938C9.64821 7.56355 9.42654 7.50022 9.20487 7.3973L8.31821 8.26813C8.78529 8.55313 9.29196 8.7273 9.77487 8.76688C9.83029 8.76688 9.88571 8.7748 9.94112 8.7748C10.9782 8.7748 11.6511 8.11772 12.0153 7.75355L12.9495 6.84313C12.9495 6.84313 13.0049 6.78772 13.0286 6.75605C13.5353 6.24938 14.042 5.62397 13.9945 4.63438C13.9232 2.90855 12.0232 0.961051 10.2895 0.834385Z" fill="#757676"/>
                         <path d="M4.60521 10.6904C4.451 10.6904 4.29638 10.6309 4.18001 10.511C3.95114 10.2768 3.95581 9.90024 4.19085 9.67144L8.99651 4.98486C9.23155 4.75598 9.60728 4.76105 9.83607 4.9957C10.0649 5.23035 10.0603 5.60608 9.82523 5.83526L5.01957 10.5219C4.90438 10.634 4.75476 10.6904 4.60521 10.6904Z" fill="#757676"/>
                       </svg>
                       </div>
                         <div onClick={()=>openClipShareModal(clipDetailPage)}>
                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                         <path d="M13.753 3.25825L13.2002 2.72713C12.0506 1.62315 11.3065 0.92735 10.6706 0.584796C10.0719 0.263221 9.40506 0.274779 8.8387 0.61575C8.51744 0.810579 8.29284 1.11592 8.14987 1.55427C8.04394 1.89136 7.98639 2.31348 7.95892 2.97682C4.77135 3.08733 0.904297 3.86515 0.904297 8.23317C0.904297 10.435 2.57115 12.4699 4.11387 13.093C4.20626 13.1301 4.30332 13.1486 4.39919 13.1486C4.59243 13.1486 4.78188 13.0744 4.92493 12.9353C5.13908 12.7265 5.20946 12.4103 5.10433 12.1297C4.47503 10.449 4.38494 9.31245 4.82835 8.65528C5.24738 8.03446 6.2509 7.69357 7.96644 7.59382C7.99391 8.28114 8.05724 8.78749 8.21265 9.1872C8.37921 9.61858 8.70973 9.94792 9.14309 10.1158C9.612 10.2966 10.1477 10.2681 10.6074 10.0384C11.2722 9.71366 12.0256 8.99396 13.2074 7.86441L13.7629 7.33098C14.5568 6.5679 14.9941 6.14736 15.0787 5.53192C15.1015 5.37422 15.1015 5.20876 15.0795 5.05724C14.9945 4.438 14.5598 4.02522 13.753 3.25825ZM13.9026 5.36575C13.8736 5.5776 13.5021 5.9348 12.9377 6.4767L12.3448 7.04575C11.3231 8.02219 10.5851 8.72804 10.0811 8.97385C9.91679 9.05579 9.72695 9.06742 9.57123 9.0086C9.45066 8.96142 9.36595 8.87798 9.31956 8.75733C9.18656 8.41565 9.15061 7.79482 9.13747 6.96682C9.13478 6.80833 9.06907 6.65759 8.95499 6.54779C8.8406 6.43878 8.68282 6.37148 8.529 6.38233C5.96305 6.44653 4.56219 6.92739 3.84391 7.99115C3.29616 8.80214 3.21771 9.89298 3.61196 11.3736C2.78395 10.626 2.09164 9.42146 2.09164 8.23317C2.09164 5.40438 3.94636 4.21997 8.49068 4.15189C8.66113 4.16424 8.83783 4.1032 8.96346 3.97717C9.09607 3.84496 9.156 3.66018 9.13241 3.48008L9.13708 3.26514C9.15022 2.80898 9.17808 2.24231 9.28053 1.91685C9.35399 1.69186 9.43055 1.64547 9.45295 1.63154C9.65823 1.50788 9.87934 1.50859 10.1085 1.63075C10.6091 1.90055 11.332 2.57932 12.3776 3.58363L12.9532 4.13637C13.5079 4.66362 13.8744 5.01156 13.9034 5.22333C13.91 5.26663 13.91 5.31706 13.9026 5.36575Z" fill="#757676"/>
                       </svg>
                       </div>
                    </div>
                  </div>
                  <div className={styles.userimgconn}>
                      <>
                        {/* <video
                          src={ clipDetailPage?.clip_Url}
                          className="videoFluidone"
              
                          preload="metadata"
                        ></video> */}
                        <div className={styles.videosection}>
              <div className={styles.videosectiontop}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                >
                  <path
                    d="M9.30846 7.3081V0H3.87366C2.21676 0 0.873657 1.3428 0.873657 3V7.3081H9.30846Z"
                    fill="white"
                  />
                  <path
                    d="M10.6915 7.3081H19.1263V3C19.1263 1.3428 17.7832 0 16.1263 0H10.6915V7.3081Z"
                    fill="white"
                  />
                  <path
                    d="M10.6915 8.6914V16H16.1263C17.7832 16 19.1263 14.6567 19.1263 13V8.6914H10.6915Z"
                    fill="white"
                  />
                  <path
                    d="M9.30846 8.6914H0.873657V13C0.873657 14.6567 2.21676 16 3.87366 16H9.30846V8.6914Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className={styles.videosectionmid}>
                {/*  Video Player place here */}
                <video
                          src={ clipDetailPage?.clip_Url}
                          className="videoFluidone"
                          ref={videoRefClip}
                          preload="metadata"
                          id="vdoClip"
                          onTimeUpdate={handleVideoTimeUpdateClip}
                        ></video>

             <div className={`${styles.videocontrolscustom} ${styles.createclipsvdocontlcustom}`}>
                  <div className={styles.vdoconfrstcol}>
                    <div className={styles.pausesvgcon} 
                    onClick={handlePlayPauseClip}
                    >
                         {/* <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                         <path d="M8.33258 0.666748H7.33325C6.59687 0.666748 5.99992 1.2637 5.99992 2.00008V10.0001C5.99992 10.7365 6.59687 11.3334 7.33325 11.3334H8.33258C9.06896 11.3334 9.66592 10.7365 9.66592 10.0001V2.00008C9.66592 1.2637 9.06896 0.666748 8.33258 0.666748Z" fill="#F7F9FC"/>
                        <path d="M2.66658 0.666748H1.66732C0.930938 0.666748 0.333984 1.2637 0.333984 2.00008V10.0001C0.333984 10.7365 0.930938 11.3334 1.66732 11.3334H2.66658C3.40296 11.3334 3.99992 10.7365 3.99992 10.0001V2.00008C3.99992 1.2637 3.40296 0.666748 2.66658 0.666748Z" fill="#F7F9FC"/>
                         </svg> */}
                           {videoStateClip === "pause" ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="14"
                                viewBox="0 0 12 14"
                                fill="none"
                              >
                                <path
                                  d="M10.7805 5.34965L6.95047 3.14182L3.1204 0.933993C2.81178 0.759899 2.48733 0.672852 2.17079 0.672852C1.17371 0.672852 0.263672 1.4721 0.263672 2.57997V11.4192C0.263672 12.535 1.17371 13.3263 2.17079 13.3263C2.48733 13.3263 2.81178 13.2472 3.1204 13.0652L6.95047 10.8574L10.7805 8.64953C12.0546 7.91358 12.0546 6.07768 10.7805 5.34965Z"
                                  fill="#F7F9FC"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="10"
                                height="12"
                                viewBox="0 0 10 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.33258 0.666504H7.33325C6.59687 0.666504 5.99992 1.26346 5.99992 1.99984V9.99984C5.99992 10.7362 6.59687 11.3332 7.33325 11.3332H8.33258C9.06896 11.3332 9.66592 10.7362 9.66592 9.99984V1.99984C9.66592 1.26346 9.06896 0.666504 8.33258 0.666504Z"
                                  fill="#F7F9FC"
                                />
                                <path
                                  d="M2.66658 0.666504H1.66732C0.930938 0.666504 0.333984 1.26346 0.333984 1.99984V9.99984C0.333984 10.7362 0.930938 11.3332 1.66732 11.3332H2.66658C3.40296 11.3332 3.99992 10.7362 3.99992 9.99984V1.99984C3.99992 1.26346 3.40296 0.666504 2.66658 0.666504Z"
                                  fill="#F7F9FC"
                                />
                              </svg>
                            )}
                     </div>
                     {/* <div className={styles.speakersvgcon}>
                       <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                       <path d="M7.01126 0.984375C6.78192 0.984375 6.54746 1.06411 6.34932 1.24204L4.57266 2.83691C4.30279 3.07924 3.95292 3.21324 3.59026 3.21324H2.50879C1.40419 3.21324 0.508789 4.10878 0.508789 5.21324V6.78664C0.508789 7.89131 1.40419 8.78664 2.50879 8.78664H3.59026C3.95299 8.78664 4.30279 8.92057 4.57266 9.16297L6.34932 10.7578C6.54759 10.9359 6.78186 11.0156 7.01126 11.0156C7.52672 11.0156 8.01739 10.6123 8.01739 10.0137V1.98631C8.01739 1.38751 7.52686 0.984175 7.01126 0.984375ZM7.01726 10.0136L5.24072 8.41891C4.78672 8.01117 4.20052 7.78657 3.59019 7.78657H2.50872C1.95732 7.78657 1.50872 7.33798 1.50872 6.78657V5.21317C1.50872 4.66177 1.95732 4.21318 2.50872 4.21318H3.59019C4.20052 4.21318 4.78679 3.98857 5.24066 3.58104L7.01732 1.98678L7.01726 10.0136Z" fill="white"/>
                       <path d="M10.1919 3.53711C9.99499 3.34504 9.67859 3.34698 9.48492 3.54424C9.29159 3.74151 9.29479 4.05858 9.49206 4.25191C9.96439 4.71417 10.2258 5.33131 10.2287 5.98891C10.232 6.65164 9.97186 7.27797 9.49692 7.75131C9.30159 7.94664 9.30099 8.26304 9.49626 8.45831C9.59392 8.55664 9.72186 8.60544 9.85012 8.60544C9.97772 8.60544 10.1057 8.55664 10.2033 8.45957C10.8687 7.79551 11.2329 6.91657 11.2287 5.98431C11.2248 5.05724 10.8563 4.18878 10.1919 3.53711Z" fill="white"/>
                          <path d="M11.8631 2.13344C11.6659 1.94071 11.3495 1.94331 11.1561 2.14124C10.9628 2.33851 10.966 2.65491 11.1633 2.84824C12.0145 3.68157 12.4862 4.79417 12.4917 5.97977C12.4969 7.17444 12.0289 8.30204 11.1737 9.15491C10.9783 9.35024 10.9777 9.66664 11.1727 9.86191C11.2707 9.96024 11.3986 10.009 11.5268 10.009C11.6544 10.009 11.7823 9.96024 11.88 9.86318C12.9256 8.82018 13.4981 7.43937 13.4913 5.97517C13.4848 4.52011 12.9067 3.15624 11.8631 2.13344Z" fill="white"/>
                           </svg>
                     </div> */}

                   </div>
                  <div className={styles.vdoconscndcol}>
                  <p>
                              {formatTime(currentTimeClip)}/
                              <span>{formatDurationnClip()}</span>
                            </p>
                  </div>
                  <div className={styles.vdoconthrdcol}>
                       {/* <div className={styles.trimsvgcon}>
                             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                               <path d="M9.10796 6.74506C8.71396 6.74506 8.3481 6.85052 8.02143 7.02112L2.82396 0.711857C2.64816 0.497657 2.33276 0.467724 2.11983 0.643524C1.9069 0.819324 1.87636 1.13439 2.05176 1.34732L5.3523 5.35386L3.9787 7.02119C3.6521 6.85059 3.2863 6.74512 2.89236 6.74512C1.5873 6.74512 0.529297 7.80306 0.529297 9.10806C0.529297 10.4131 1.5873 11.471 2.89236 11.471C4.19743 11.471 5.25543 10.4131 5.25543 9.10806C5.25543 8.55986 5.06096 8.06152 4.74763 7.66046L6.00016 6.14026L7.2527 7.66079C6.93936 8.06152 6.74503 8.55986 6.74503 9.10806C6.74503 10.4131 7.80296 11.471 9.10803 11.471C10.4131 11.471 11.4711 10.4131 11.4711 9.10806C11.4711 7.80306 10.4131 6.74506 9.10796 6.74506ZM2.89236 10.471C2.14076 10.471 1.5293 9.85966 1.5293 9.10806C1.5293 8.35646 2.14076 7.74512 2.89236 7.74512C3.64396 7.74512 4.25543 8.35646 4.25543 9.10806C4.25543 9.85966 3.64396 10.471 2.89236 10.471ZM9.10796 10.471C8.35643 10.471 7.74496 9.85966 7.74496 9.10806C7.74496 8.35646 8.35643 7.74512 9.10796 7.74512C9.8595 7.74512 10.471 8.35646 10.471 9.10806C10.471 9.85966 9.85956 10.471 9.10796 10.471Z" fill="white"/>
                             <path d="M9.94863 1.34726C10.1241 1.13439 10.0935 0.819257 9.88056 0.643457C9.66736 0.467057 9.35223 0.49759 9.17643 0.71179L6.5057 3.95366L7.1535 4.74012L9.94863 1.34726Z" fill="white"/>
                           </svg>
                        </div> */}
                        {/* <div className={styles.frwrdcon}>
                           <p>1x</p>
                         </div> */}
                        <div className={styles.fullscreensvgcon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none" >
                                <path d="M12.471 11.313H9.66016C9.38409 11.313 9.16016 11.0891 9.16016 10.813C9.16016 10.5369 9.38409 10.313 9.66016 10.313H12.471C12.5628 10.313 12.6377 10.2381 12.6377 10.1463V7.33773C12.6377 7.06166 12.8616 6.83773 13.1377 6.83773C13.4138 6.83773 13.6377 7.06166 13.6377 7.33773V10.1463C13.6377 10.7895 13.1142 11.313 12.471 11.313Z" fill="#F7F9FC"/>
                               <path d="M13.1377 5.16657C12.8616 5.16657 12.6377 4.94263 12.6377 4.66657V1.85343C12.6377 1.76163 12.5628 1.68677 12.471 1.68677H9.66048C9.38442 1.68677 9.16048 1.46283 9.16048 1.18677C9.16048 0.910701 9.38442 0.686768 9.66048 0.686768H12.471C13.1142 0.686768 13.6377 1.21023 13.6377 1.85343V4.66657C13.6377 4.94263 13.4137 5.16657 13.1377 5.16657Z" fill="#F7F9FC"/>
                            <path d="M4.33984 11.313H1.52897C0.885771 11.313 0.362305 10.7895 0.362305 10.1463V7.33773C0.362305 7.06166 0.586238 6.83773 0.862305 6.83773C1.13837 6.83773 1.3623 7.06166 1.3623 7.33773V10.1463C1.3623 10.2381 1.43717 10.313 1.52897 10.313H4.33984C4.6159 10.313 4.83984 10.5369 4.83984 10.813C4.83984 11.0891 4.6159 11.313 4.33984 11.313Z" fill="#F7F9FC"/>
                                  <path d="M0.862305 5.16657C0.586238 5.16657 0.362305 4.94263 0.362305 4.66657V1.85343C0.362305 1.21023 0.885771 0.686768 1.52897 0.686768H4.3395C4.61557 0.686768 4.8395 0.910701 4.8395 1.18677C4.8395 1.46283 4.61557 1.68677 4.3395 1.68677H1.52897C1.43717 1.68677 1.3623 1.76163 1.3623 1.85343V4.66657C1.3623 4.94263 1.13837 5.16657 0.862305 5.16657Z" fill="#F7F9FC"/>
                            </svg>
                        </div>
                  </div>
                    <div className={styles.loaderbar}
                          ref={loaderBarRefClip}
                          onMouseDown={handleMouseDownClip}
                    >
                        <div  className={styles.progressbar} 
                                 style={{ width: `${(videoRefClip.current?.currentTime / videoRefClip.current?.duration) * 100}%` }}>

                          </div>
                          <div className={styles.loaderindicator}
                                 style={{ left: `${(videoRefClip.current?.currentTime / videoRefClip.current?.duration) * 100}%` 
                                          //
                                          }}
                                         // onClick={()=>handleDragStartRec(start)}
                                         ></div>
                    </div>
                </div>
              </div>
              <div className={styles.videosectionbottom}>
                <p>
                  {clips && clips?.length >0 ?  `` : `No Clips found in recording.`}
                 
                </p>
              </div>
            </div>

                        

                      </>
                    
                  </div>

                
                </div>
              </div>
            </Modal>


          
            <Modal
              centered
              visible={clipShareModal}
              title = "Share Clips"
              footer={[
                <>
                  <Button key="cancel" className="ShareClipscancel" onClick={closeClipShareModal} >Cancel</Button>
                  <Button key="Share"
                   className={`${shareButtonEnabled ? 'clipmodbtnactive' : 'clipmodbtndisable'}`}
                   onClick={() => shareFile("clips")}
                   disabled={!shareButtonEnabled}>Share</Button>
                </>
              ]}
              onCancel={closeClipShareModal}
              className="clipShare"
              maskClosable={false}>
              
              <div>
              <div className={styles.ppmetricssectionn}>
                   <Select
            mode="multiple"
            style={{ width: '100%' }}
            filterOption={false}
            showSearch={true}
            value={getrecData.shareCon}
            onSearch={searchContact}
            placeholder="Search name or extension"
            className="newselects taskcreations customdropbox inputselectlftnone"
            dropdownClassName="newChatSel meetingdropdown"
            onChange={selectContact}
          >
           {/* {(favContacts?.length > 0) &&
                    <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favContacts?.map((favcontactName: any, index: any) => {

                    return <div key={index} value={favcontactName.sip_login_id}>

                      <div className="dropdowndesign">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                              (<>
                                <img src={favcontactName.ImageURL} alt="" />
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                              </>)
                          } />
                        <div className="names">{favcontactName.caller_id}</div>
                        <div className="ext">{favcontactName.ext}</div>
                      </div>
                    </div>;
                  })} */}
                  {getrecData.allContacts && getrecData.allContacts.map((contactName: any, innndex: any) => {

                    return (
                      <option key={JSON.stringify(contactName)} value={contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}>
                        {
                    ((getrecData.allContacts[innndex - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                    ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                    <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
                  }
                        <div className="dropdowndesign">
                          <div className="usergroupss">
                            <URAvatarGroup className={`lefts size22 colorBG${random_color[innndex]}`} profileInfo={<>
                              {(contactName.ImageURL || contactName.profile_image_url) ?
                                <img src={contactName.caller_id ? contactName?.ImageURL : contactName.team_name ? contactName?.profile_image_url : ""} alt="" /> :
                                <span>{contactName?.caller_id ? contactName.caller_id.toUpperCase().charAt(0) : contactName?.team_name.toUpperCase().charAt(0)}</span>}
                            </>} />
                            <div  className="names">{contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}</div>
                          </div>
                          <div className="ext">{contactName?.ext ? contactName.ext : ''}</div>
                        </div>
                      </option>);
                       })}


          </Select>
              
              </div>
              </div>
            </Modal>
            
            <Modal
              centered
              visible={recShareModal}
              title = "Share This Recorded Video"
              footer={[
                <>
                  <Button key="cancel" className="ShareClipscancel" onClick={closeRecShareModal} >Cancel</Button>
                  <Button key="Share"
                   className={`${shareButtonEnabled ? 'clipmodbtnactive' : 'clipmodbtndisable'}`}
                   onClick={() => shareFile("record")}
                   disabled={!shareButtonEnabled}>Share</Button>
                </>
              ]}
              onCancel={closeRecShareModal}
              className="clipShare"
              maskClosable={false}>
              
              <div>
              <div className={styles.ppmetricssectionn}>
                   <Select
            mode="multiple"
            style={{ width: '100%' }}
            filterOption={false}
            showSearch={true}
            value={getrecData.shareCon}
            onSearch={searchContact}
            placeholder="Search name or extension"
            className="newselects taskcreations customdropbox inputselectlftnone"
            dropdownClassName="newChatSel meetingdropdown"
            onChange={selectContact}
          >
           {/* {(favContacts?.length > 0) &&
                    <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favContacts?.map((favcontactName: any, index: any) => {

                    return <div key={index} value={favcontactName.sip_login_id}>

                      <div className="dropdowndesign">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                              (<>
                                <img src={favcontactName.ImageURL} alt="" />
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                              </>)
                          } />
                        <div className="names">{favcontactName.caller_id}</div>
                        <div className="ext">{favcontactName.ext}</div>
                      </div>
                    </div>;
                  })} */}
                  {getrecData.allContacts && getrecData.allContacts.map((contactName: any, innndex: any) => {

                    return (
                      <option key={JSON.stringify(contactName)} value={contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}>
                        {
                    ((getrecData.allContacts[innndex - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                    ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                    <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
                  }
                        <div className="dropdowndesign">
                          <div className="usergroupss">
                            <URAvatarGroup className={`lefts size22 colorBG${random_color[innndex]}`} profileInfo={<>
                              {(contactName.ImageURL || contactName.profile_image_url) ?
                                <img src={contactName.caller_id ? contactName?.ImageURL : contactName.team_name ? contactName?.profile_image_url : ""} alt="" /> :
                                <span>{contactName?.caller_id ? contactName.caller_id.toUpperCase().charAt(0) : contactName?.team_name.toUpperCase().charAt(0)}</span>}
                            </>} />
                            <div  className="names">{contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}</div>
                          </div>
                          <div className="ext">{contactName?.ext ? contactName.ext : ''}</div>
                        </div>
                      </option>);
                       })}


          </Select>
              
              </div>
              </div>
            </Modal>
            <Modal
              centered
              visible={recShareModal}
              title = "Share Recording Video"
              footer={[
                <>
                  <Button key="cancel" className="ShareClipscancel" onClick={closeRecShareModal} >Cancel</Button>
                  <Button key="Share"
                   className={`${shareButtonEnabled ? 'clipmodbtnactive' : 'clipmodbtndisable'}`}
                   onClick={() => shareFile("record")}
                   disabled={!shareButtonEnabled}>Share</Button>
                </>
              ]}
              onCancel={closeRecShareModal}
              className="clipShare"
              maskClosable={false}>
              
              <div>
              <div className={styles.ppmetricssectionn}>
                   <Select
            mode="multiple"
            style={{ width: '100%' }}
            filterOption={false}
            showSearch={true}
            value={getrecData.shareCon}
            onSearch={searchContact}
            placeholder="Search name or extension"
            className="newselects taskcreations customdropbox inputselectlftnone"
            dropdownClassName="newChatSel meetingdropdown"
            onChange={selectContact}
          >
           {/* {(favContacts?.length > 0) &&
                    <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favContacts?.map((favcontactName: any, index: any) => {

                    return <div key={index} value={favcontactName.sip_login_id}>

                      <div className="dropdowndesign">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                              (<>
                                <img src={favcontactName.ImageURL} alt="" />
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                              </>)
                          } />
                        <div className="names">{favcontactName.caller_id}</div>
                        <div className="ext">{favcontactName.ext}</div>
                      </div>
                    </div>;
                  })} */}
                  {getrecData.allContacts && getrecData.allContacts.map((contactName: any, innndex: any) => {

                    return (
                      <option key={JSON.stringify(contactName)} value={contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}>
                        {
                    ((getrecData.allContacts[innndex - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                    ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                    <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
                  }
                        <div className="dropdowndesign">
                          <div className="usergroupss">
                            <URAvatarGroup className={`lefts size22 colorBG${random_color[innndex]}`} profileInfo={<>
                              {(contactName.ImageURL || contactName.profile_image_url) ?
                                <img src={contactName.caller_id ? contactName?.ImageURL : contactName.team_name ? contactName?.profile_image_url : ""} alt="" /> :
                                <span>{contactName?.caller_id ? contactName.caller_id.toUpperCase().charAt(0) : contactName?.team_name.toUpperCase().charAt(0)}</span>}
                            </>} />
                            <div  className="names">{contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}</div>
                          </div>
                          <div className="ext">{contactName?.ext ? contactName.ext : ''}</div>
                        </div>
                      </option>);
                       })}


          </Select>
              
              </div>
              </div>
            </Modal>

            
            <Modal
              centered
              visible={clipModal}
              title="Create Clip"
              maskClosable={false}
              footer={[
                <>
                  <Button className="btnnnnn" key="cancel"onClick={handleCancelClick} >Cancel</Button>
                  <Button
                   key="trim"
                   className={`${(isTrimButtonEnabled && isLoading) ? `clipmodbtnactive` :  `clipmodbtndisable`}`}
                    onClick={trimVdo}>Trim</Button>
                </>
              ]}
              onCancel={closeModalClip}
              className="createclipmodal trimmodall"
            >
              <div className={styles.paddingtoppcreateclip}>
                <div className={styles.ppmetricssectionn}>
                  <div className={styles.userimgconn}>
                    {!isLoading ? (
                      <>
                        <video
                          ref={videoRef}
                          src={recURL}
                          crossOrigin="anonymous"
                          preload="auto"
                          style={{ display: "none" }}
                          id="vdo"
                        ></video>
                        <canvas
                          ref={canvasRef}
                          style={{ display: "none" }}
                        ></canvas>
                           <div ><Lottie className="svgLoadinglistcenter" animationData={ContactLoader} /></div>
                        <div>
                          {frames.map((frame, index) => (
                            <img 
                              key={index}
                              src={frame}
                              alt={`Frame ${index}`}
                              style={{
                                width: "50px",
                                height: "auto",
                                cursor: "pointer",
                                display: "none"
                              }}
                              onClick={() => {
                                if (videoRef.current) {
                                  videoRef.current.currentTime = index;
                                }
                              }}
                            />
                          ))}
                        </div>
                      </>
                    ) : (
                      <>
                        <video
                          ref={videoRef}
                          src={recURL}
                          crossOrigin="anonymous"
                          preload="auto"
                          onTimeUpdate={handleVideoTimeUpdate}
                        ></video>
                        <div className="vdotoolbarsec">
                          <div
                            className="pausesection"
                            onClick={handlePlayPause}
                          >
                            {videoState === "pause" ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="14"
                                viewBox="0 0 12 14"
                                fill="none"
                              >
                                <path
                                  d="M10.7805 5.34965L6.95047 3.14182L3.1204 0.933993C2.81178 0.759899 2.48733 0.672852 2.17079 0.672852C1.17371 0.672852 0.263672 1.4721 0.263672 2.57997V11.4192C0.263672 12.535 1.17371 13.3263 2.17079 13.3263C2.48733 13.3263 2.81178 13.2472 3.1204 13.0652L6.95047 10.8574L10.7805 8.64953C12.0546 7.91358 12.0546 6.07768 10.7805 5.34965Z"
                                  fill="#F7F9FC"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="10"
                                height="12"
                                viewBox="0 0 10 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.33258 0.666504H7.33325C6.59687 0.666504 5.99992 1.26346 5.99992 1.99984V9.99984C5.99992 10.7362 6.59687 11.3332 7.33325 11.3332H8.33258C9.06896 11.3332 9.66592 10.7362 9.66592 9.99984V1.99984C9.66592 1.26346 9.06896 0.666504 8.33258 0.666504Z"
                                  fill="#F7F9FC"
                                />
                                <path
                                  d="M2.66658 0.666504H1.66732C0.930938 0.666504 0.333984 1.26346 0.333984 1.99984V9.99984C0.333984 10.7362 0.930938 11.3332 1.66732 11.3332H2.66658C3.40296 11.3332 3.99992 10.7362 3.99992 9.99984V1.99984C3.99992 1.26346 3.40296 0.666504 2.66658 0.666504Z"
                                  fill="#F7F9FC"
                                />
                              </svg>
                            )}
                          </div>
                          <div className="trimmer-container">
                            <div className="progressbar"></div>

                            {/* <Tooltip title ={formatTimeDate(videoRef.current?.currentTime)}> */}
                            <div
                              className="trimmer-bar"
                              onMouseMove={handleDragMove}
                              onMouseUp={handleDragEnd}
                              onMouseDown={handleBarDragStart}
                              onMouseLeave={handleDragEnd}
                              //  title =  {videoRef.current?.currentTime}
                            >
                              <style>
                                {`
                                .trimmer-bar::after {
                                  content: "";
                                  position: absolute;
                                  top: 0;
                                  left:${
                                    (trimEnd / videoRef.current?.duration ||
                                      0) * 100
                                  }%;
                                  width: 100%;
                                  height: 100%;
                                  pointer-events: none;
                                  background: black;
                                  opacity:.5
                              }
                              .trimmer-bar::before {
                                  content: "";
                                  position: absolute;
                                  top: 0;
                                  left: 0;
                                  width: ${
                                    (trimStart / videoRef.current?.duration ||
                                      0) * 100
                                  }%;
                                  height: 100%;
                                  pointer-events: none;
                                  background: black;
                                  opacity:.5
                              }
                            `}
                              </style>
                              <div className="tooltipsmartepd">
                                <Tooltip
                                  title={formatTimeDate(
                                    videoRef.current?.currentTime
                                  )}
                                >
                                  <div
                                    className="trimmer-fill"
                                    style={{
                                      left: `${
                                        (trimStart /
                                          (videoRef.current?.duration || 1)) *
                                        100
                                      }%`,
                                      width: `${
                                        ((trimEnd - trimStart) /
                                          (videoRef.current?.duration || 1)) *
                                        100
                                      }%`
                                    }}
                                  >
                                    {/* <div
                                      className={styles.redline}
                                      style={{
                                        left: `${
                                          (videoRef.current?.currentTime /
                                            videoRef.current?.duration || 0) *
                                          100
                                        }%`
                                      }}
                                    /> */}
                                  </div>
                                </Tooltip>
                              </div>

                              <div
                                className="trimmer-start"
                                style={{
                                  left: `${
                                    (trimStart / videoRef.current?.duration ||
                                      0) * 100
                                  }%`
                                }}
                                onMouseDown={() => handleDragStart("start")}
                              />
                              <div
                                className="trimmer-end"
                                style={{
                                  left: `${
                                    (trimEnd / videoRef.current?.duration ||
                                      0) * 100
                                  }%`
                                }}
                                onMouseDown={() => handleDragStart("end")}
                              />
                              {/* {videoRef.current?.currentTime !== 0 &&  (
                      <div
                        className={styles.redline}
                        style={{ left: `${(videoRef.current?.currentTime / videoRef.current?.duration || 0) * 100}%` }}
                      />
                    )
                  
                    } */}

                              {/* <div
                        className={styles.redline}
                        style={{ left
                        : `${(videoRef.current?.currentTime / videoRef.current?.duration || 0) * 100}%` }}
                      />
                  */}


                                  {((videoRef.current?.currentTime - trimStart) > 3) && 
                                    ((trimEnd - videoRef.current?.currentTime ) > 4) && 
                                    (
                                    <div
                                      className={styles.redline}
                                      style={{ left: `${(videoRef.current?.currentTime / videoRef.current?.duration || 0) * 100}%` }}
                                    />
                                  )}
                            </div>
                            <div className={styles.scrollContainer}>
                              {frames.map((frame, index) => {
                                const frameTime = interval * index;
                                return (
                                  <Tooltip
                                    key={index}
                                    title={formatTimeDate(frameTime)}
                                    // title="hello"
                                    // placement="top"
                                    trigger="hover"
                                  >
                                    <img
                                      key={index}
                                      src={frame}
                                      alt={`Frame ${index}`}
                                      className={styles.frameImage}
                                      style={{
                                        width: `${frameWidth}px`,
                                        height: `40px`,
                                        cursor: "pointer"
                                      }}
                                      // title="there"
                                      // title={formatTimeDate(frameTime)}
                                      // onMouseMove={() => console.log(`Hovered over frame ${index}`,`Interval ${(index * interval)+5}`)}
                                      onClick={() => {
                                        // Handle click event if needed
                                        if (videoRef.current) {
                                          videoRef.current.currentTime =
                                            index * 10; // Adjust as per your frame time logic
                                        }
                                      }}
                                    />
                                  </Tooltip>
                                );
                              })}
                            </div>
                          </div>

                          <div className="durationsection">
                            <p>
                              {formatTime(currentTime)}/
                              <span>{formatDurationn()}</span>
                            </p>
                          </div>
                        </div>
                        <canvas
                          ref={canvasRef}
                          style={{ display: "none" }}
                        ></canvas>
                      </>
                    )}
                  </div>

                  <div className={styles.buttonsection}>
                  <div className={styles.btnsectionflexcon}>
                <div>
                 <span className={`${styles.timeEdit} ${styles.jhds}`} id="trimStartInput" data-name="trimStart">
                 {formatTime(trimStart)}
                 </span>
               </div>
             <div> - </div>
                 <div>
                  <span className={`${styles.timeEdit} ${styles.jhds}`} id="trimEndInput" data-name="trimEnd">
                  {formatTime(trimEnd)}
                  </span>
                 </div>
                <div>{formatDuration(calculateDuration())}</div>
                </div>
                  </div>
                  <div className={styles.modalrow}>
                    <label>
                      Title Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter title name"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    ></input>
                  </div>
                  <div className={styles.modalrow}>
                    <label>
                      Description
                    </label>
                    <textarea
                      placeholder="Enter description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>
            </Modal>
            <Modal
              centered
              visible={playlistModal}
              title="Add clip to playlist"
              onCancel={closePlayListModal}
              className="modallnewst"
              onOk={addClips}
            >
              <div>
                <div className={styles.ppmetricssectionn}>
                  <div>
                    <div className={styles.modalrow}>
                      <label>
                        Title Name <span>*</span>
                      </label>
                      <div className={styles.shareSelect}>
                        <Select
                          mode="multiple"
                          style={{ width: "100%" }}
                          filterOption={false}
                          showSearch={true}
                          // options={options}
                          placeholder="Select Playlist"
                          className="createNewSel"
                          dropdownClassName="newChatSel"
                          onChange={handleChange}
                          ></Select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>

            <Tabs defaultActiveKey="1" className="smarttabs bgnewtab smarttabsbgnewtab" onChange={handleTab}>
              <TabPane tab="Recorded videos" key="1">
                {recordlist &&
                Array.isArray(recordlist) &&
                recordlist?.length > 0 ? (
                  <div className={styles.videotable}>
                    <div className={styles.videotabletitle}>
                      <div className={styles.videotablevalue}>
                        <input
                          type="checkbox"
                          name=""
                          id="recordSelectAll"
                          onClick={selectAllRecord}
                        />
                      </div>
                      <div className={styles.videotablevalue}>
                       <p className={styles.sortingiconelem}> {selectedRec && selectedRec.length > 0 ? `${selectedRec.length} Selected` : 'Record thumbnail' }
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
                        <path d="M1.49999 4.72589H6.50006C7.32672 4.72589 7.73339 3.71922 7.14006 3.14582L4.64012 0.725887C4.46012 0.552554 4.23012 0.46582 4.00006 0.46582C3.76999 0.46582 3.54012 0.552554 3.36006 0.725887L0.860058 3.14582C0.266724 3.71922 0.673324 4.72589 1.49999 4.72589ZM3.99999 1.49815L6.30146 3.72589H1.69852L3.99999 1.49815Z" fill="#757676"/>
                        <path d="M6.49999 6.27402H1.49992C0.673257 6.27402 0.266591 7.28069 0.859924 7.85409L3.35992 10.274C3.53992 10.4474 3.76992 10.5341 3.99992 10.5341C4.22992 10.5341 4.45999 10.4474 4.63999 10.274L7.13992 7.85409C7.73326 7.28069 7.32666 6.27402 6.49999 6.27402ZM4.00006 9.50175L1.69852 7.27402H6.30146L4.00006 9.50175Z" fill="#757676"/>
                       </svg>
                       </span>
                       </p>
                        {selectedRec && selectedRec.length > 0 && <div className={styles.vdotableiconflex}>
                          {/* <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M6.40976 7.11638L5.66309 7.84972C5.74309 8.03638 5.78976 8.21638 5.79643 8.38972C5.81643 8.81638 5.60976 9.09638 5.20976 9.48305C5.1831 9.50305 5.16309 9.52972 5.1431 9.55638L4.4231 10.2564C4.0231 10.6564 3.72976 10.8497 3.3031 10.8297C2.35643 10.763 1.1431 9.52972 1.10976 8.59638C1.08976 8.15638 1.2831 7.89638 1.71643 7.46971C1.76976 7.41638 2.09643 7.10305 2.3031 6.89638L2.5031 6.70305C2.8631 6.34305 3.1431 6.14305 3.52976 6.14305H3.6031C3.74976 6.15638 3.9031 6.18971 4.05643 6.25638L4.80976 5.51638C4.4431 5.30305 4.04976 5.17638 3.66976 5.14971C2.70309 5.08305 2.11643 5.67638 1.79643 5.99638L1.60976 6.18305C1.36976 6.41638 1.00309 6.76971 1.00309 6.77638C0.549762 7.20971 0.0697617 7.74971 0.109762 8.63638C0.169762 10.083 1.77643 11.723 3.23643 11.823C3.2831 11.8297 3.32976 11.8297 3.37643 11.8297C4.25643 11.8297 4.81643 11.2764 5.1231 10.9764L5.90976 10.2097C5.90976 10.2097 5.95643 10.1564 5.97643 10.1297C6.4031 9.70972 6.82976 9.18305 6.79643 8.34305C6.7831 7.93638 6.6431 7.51638 6.40976 7.11638Z"
                                fill="#3E3F40"
                              />
                              <path
                                d="M8.76976 0.176382C7.80309 0.103048 7.20976 0.709715 6.89643 1.02305L6.76976 1.14305C6.5431 1.36971 6.1031 1.80305 6.09643 1.80971C5.64976 2.24305 5.16976 2.77638 5.20976 3.66305C5.2231 4.03638 5.3431 4.42972 5.5431 4.80305L6.30309 4.06305C6.24309 3.91638 6.20976 3.76305 6.2031 3.62305C6.18976 3.18971 6.38976 2.91638 6.81643 2.50305C6.87643 2.44305 7.26309 2.06305 7.46976 1.86305L7.6031 1.73638C7.9631 1.37638 8.23643 1.16972 8.62976 1.16972C8.64976 1.16972 8.67643 1.17638 8.7031 1.17638C9.64976 1.24305 10.8564 2.47638 10.8964 3.41638C10.9098 3.84972 10.7164 4.11638 10.3098 4.50972C10.2831 4.53638 10.2631 4.56305 10.2431 4.58972L9.5231 5.28971C9.11643 5.68971 8.82976 5.87638 8.4031 5.85638C8.22976 5.84305 8.0431 5.78972 7.85643 5.70305L7.10976 6.43638C7.5031 6.67638 7.92976 6.82305 8.33643 6.85638C8.38309 6.85638 8.42976 6.86305 8.47643 6.86305C9.34976 6.86305 9.91643 6.30972 10.2231 6.00305L11.0098 5.23638C11.0098 5.23638 11.0564 5.18972 11.0764 5.16305C11.5031 4.73638 11.9298 4.20971 11.8898 3.37638C11.8298 1.92305 10.2298 0.283048 8.76976 0.176382Z"
                                fill="#3E3F40"
                              />
                              <path
                                d="M3.98303 8.47618C3.85316 8.47618 3.72296 8.42605 3.62496 8.32512C3.43223 8.12785 3.43616 7.81078 3.63409 7.61812L7.68096 3.67152C7.8789 3.47878 8.1953 3.48305 8.38796 3.68065C8.58063 3.87825 8.57676 4.19465 8.37883 4.38765L4.33196 8.33425C4.23496 8.42865 4.10896 8.47618 3.98303 8.47618Z"
                                fill="#3E3F40"
                              />
                            </svg>
                          </div> */}
                          <div  onClick={openMultiShareRec}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M10.8443 3.05956L10.3789 2.61229C9.41081 1.68262 8.78415 1.09669 8.24868 0.808224C7.74448 0.537424 7.18295 0.547157 6.70601 0.83429C6.43548 0.998357 6.24635 1.25549 6.12595 1.62462C6.03675 1.90849 5.98828 2.26396 5.96515 2.82256C3.28088 2.91562 0.0244141 3.57062 0.0244141 7.24896C0.0244141 9.10309 1.42808 10.8167 2.72721 11.3414C2.80501 11.3727 2.88675 11.3883 2.96748 11.3883C3.13021 11.3883 3.28975 11.3258 3.41021 11.2086C3.59055 11.0328 3.64981 10.7666 3.56128 10.5302C3.03135 9.11489 2.95548 8.15782 3.32888 7.60442C3.68175 7.08162 4.52681 6.79456 5.97148 6.71056C5.99461 7.28936 6.04795 7.71576 6.17881 8.05236C6.31908 8.41562 6.59741 8.69296 6.96235 8.83429C7.35721 8.98662 7.80835 8.96256 8.19541 8.76916C8.75528 8.49569 9.38975 7.88962 10.3849 6.93842L10.8527 6.48922C11.5213 5.84662 11.8895 5.49249 11.9607 4.97422C11.9799 4.84142 11.9799 4.70209 11.9614 4.57449C11.8898 4.05302 11.5237 3.70542 10.8443 3.05956ZM10.9703 4.83429C10.9459 5.01269 10.6331 5.31349 10.1578 5.76982L9.65848 6.24902C8.79815 7.07129 8.17668 7.66569 7.75221 7.87269C7.61388 7.94169 7.45401 7.95149 7.32288 7.90196C7.22135 7.86222 7.15001 7.79196 7.11095 7.69036C6.99895 7.40262 6.96868 6.87982 6.95761 6.18256C6.95535 6.04909 6.90001 5.92216 6.80395 5.82969C6.70761 5.73789 6.57475 5.68122 6.44521 5.69036C4.28441 5.74442 3.10475 6.14936 2.49988 7.04516C2.03861 7.72809 1.97255 8.64669 2.30455 9.89349C1.60728 9.26396 1.02428 8.24962 1.02428 7.24896C1.02428 4.86682 2.58615 3.86942 6.41295 3.81209C6.55648 3.82249 6.70528 3.77109 6.81108 3.66496C6.92275 3.55362 6.97321 3.39802 6.95335 3.24636L6.95728 3.06536C6.96835 2.68122 6.99181 2.20402 7.07808 1.92996C7.13995 1.74049 7.20441 1.70142 7.22328 1.68969C7.39615 1.58556 7.58235 1.58616 7.77535 1.68902C8.19688 1.91622 8.80561 2.48782 9.68615 3.33356L10.1709 3.79902C10.638 4.24302 10.9466 4.53602 10.971 4.71436C10.9765 4.75082 10.9765 4.79329 10.9703 4.83429Z"
                                fill="#3E3F40"
                              />
                            </svg>
                          </div>
                          {/* <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M10.667 5.33329H6.66699V1.33329C6.66699 0.964826 6.36879 0.666626 6.00033 0.666626C5.63186 0.666626 5.33366 0.964826 5.33366 1.33329V5.33329H1.33366C0.965192 5.33329 0.666992 5.63149 0.666992 5.99996C0.666992 6.36843 0.965192 6.66663 1.33366 6.66663H5.33366V10.6666C5.33366 11.0351 5.63186 11.3333 6.00033 11.3333C6.36879 11.3333 6.66699 11.0351 6.66699 10.6666V6.66663H10.667C11.0355 6.66663 11.3337 6.36843 11.3337 5.99996C11.3337 5.63149 11.0355 5.33329 10.667 5.33329Z"
                                fill="#3E3F40"
                              />
                            </svg>
                          </div> */}
                          <div onClick={openConfirmRecModal}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="14"
                              viewBox="0 0 12 14"
                              fill="none"
                            >
                              <path
                                d="M4.92031 10.9562C4.64424 10.9562 4.42031 10.7323 4.42031 10.4562V4.74305C4.42031 4.46698 4.64424 4.24305 4.92031 4.24305C5.19638 4.24305 5.42031 4.46698 5.42031 4.74305V10.4562C5.42031 10.7323 5.19638 10.9562 4.92031 10.9562Z"
                                fill="#3E3F40"
                              />
                              <path
                                d="M7.08044 10.9562C6.80438 10.9562 6.58044 10.7323 6.58044 10.4562V4.74305C6.58044 4.46698 6.80438 4.24305 7.08044 4.24305C7.35651 4.24305 7.58044 4.46698 7.58044 4.74305V10.4562C7.58044 10.7323 7.35651 10.9562 7.08044 10.9562Z"
                                fill="#3E3F40"
                              />
                              <path
                                d="M11.447 1.97645H8.81351V1.56985C8.81351 0.864117 8.25751 0.289917 7.57391 0.289917H4.42024C3.73664 0.289917 3.18031 0.864117 3.18031 1.56985V1.97645H0.553711C0.277644 1.97645 0.0537109 2.20038 0.0537109 2.47645C0.0537109 2.75252 0.277644 2.97645 0.553711 2.97645H0.956578L1.46811 11.4055C1.54298 12.6979 2.61718 13.7102 3.91378 13.7102H8.07391C9.36951 13.7102 10.4496 12.6965 10.5329 11.4003L11.0448 2.97652H11.447C11.723 2.97652 11.947 2.75258 11.947 2.47652C11.947 2.20045 11.723 1.97645 11.447 1.97645ZM4.18038 1.56985C4.18038 1.41558 4.28811 1.28992 4.42031 1.28992H7.57398C7.70611 1.28992 7.81358 1.41558 7.81358 1.56985V1.97645H4.18044L4.18038 1.56985ZM9.53485 11.3378C9.48538 12.1073 8.84344 12.7102 8.07391 12.7102H3.91378C3.14651 12.7102 2.51044 12.1119 2.46618 11.3463L1.95831 2.97645H10.0424L9.53485 11.3378Z"
                                fill="#3E3F40"
                              />
                            </svg>
                          </div>
                        </div>}
                      </div>
                      <div className={styles.videotablevalue}>Actions</div>
                    </div>
                    {recordlist.map((ele: any, index: any) => {
                      return (
                        <div
                          className={styles.videotabledescription}
                          key={index}
                          onClick={() => saverecordlist(ele)}
                        >
                          <div className={styles.videotablevalue}>
                            <input
                              type="checkbox"
                              name=""
                              className="checkbox-item-record"
                              onClick={()=>selectRecord(ele)}
                            />
                          </div>
                          <div className={styles.videotablevalue}>
                            <div className={styles.cliparea}>
                              <div className={styles.cliparealeft}>
                                <img src={ele.thumbnail_url} alt="Thumbnail Null"/>
                              </div>
                              <div className={styles.cliparearight}>
                                <h3 className={styles.playingbtnvisiblediv}>{`${ele.meeting_name}`}
                                {recordDetailPage.unique_id === ele.unique_id && videoStateRec === "play" && (
                                   <span>
                                  <div className={styles.recorderdtmpplaybtn}>Playing</div>
                                    </span>
                                       )}</h3> 
                                {/* <p>{`${ele.meeting_name}`}</p> */}
                                <p>{`${bytesToSize(
                                  ele.record_size
                                )} `} <span className={styles.dattendtimespann}>{formatDate(ele.createdate)}</span></p>
                             
                              </div>
                            </div>
                          </div>
                          <div className={styles.videotablevalue}> 
                            <div className={styles.threedothoverdiv}>
                            <Dropdown overlay={RecIndMenuai(ele)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="4"
                                height="12"
                                viewBox="0 0 4 12"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M2.00006 3.00867C2.82266 3.00867 3.49573 2.3356 3.49573 1.513C3.49573 0.690401 2.82266 0.017334 2.00006 0.017334C1.17746 0.017334 0.504395 0.690401 0.504395 1.513C0.504395 2.3356 1.17746 3.00867 2.00006 3.00867ZM2.00006 4.50433C1.17746 4.50433 0.504395 5.1774 0.504395 6C0.504395 6.8226 1.17746 7.49567 2.00006 7.49567C2.82266 7.49567 3.49573 6.8226 3.49573 6C3.49573 5.1774 2.82266 4.50433 2.00006 4.50433ZM0.504395 10.487C0.504395 9.6644 1.17746 8.99133 2.00006 8.99133C2.82266 8.99133 3.49573 9.6644 3.49573 10.487C3.49573 11.3096 2.82266 11.9827 2.00006 11.9827C1.17746 11.9827 0.504395 11.3096 0.504395 10.487Z"
                                  fill="#757676"
                                />
                              </svg>
                            </Dropdown>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    {" "}
                    {recLoad ? (
                      <>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((index: any) => (
                          <div key={index}>
                            <URChatLeftSkeleton />
                          </div>
                        ))}
                      </>
                    ) : (
                      <NoContent
                        image={noResult}
                        title={""}
                        description={"No meetings found"}
                      />
                    )}{" "}
                  </>
                )}
                {recLoad && recordlist?.length > 0 && (
                  <div className="skeletonMeetingbottom ">
                    <Lottie
                      className="svgLoading"
                      animationData={ContactLoader}
                    />
                  </div>
                )}{" "}
              </TabPane>
              {/* <TabPane tab="Smart Episodes" key="2">
                {/* <div className={styles.videotable}>
                  <div className={styles.videotabletitle}>
                    <div className={styles.videotablevalue}><input type="checkbox" name="" onChange={selectRecord}/></div>
                    <div className={styles.videotablevalue}>Clip thumnail
                    <div className={styles.vdotableiconflex}> 
                      
                      <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                       <path d="M6.40976 7.11638L5.66309 7.84972C5.74309 8.03638 5.78976 8.21638 5.79643 8.38972C5.81643 8.81638 5.60976 9.09638 5.20976 9.48305C5.1831 9.50305 5.16309 9.52972 5.1431 9.55638L4.4231 10.2564C4.0231 10.6564 3.72976 10.8497 3.3031 10.8297C2.35643 10.763 1.1431 9.52972 1.10976 8.59638C1.08976 8.15638 1.2831 7.89638 1.71643 7.46971C1.76976 7.41638 2.09643 7.10305 2.3031 6.89638L2.5031 6.70305C2.8631 6.34305 3.1431 6.14305 3.52976 6.14305H3.6031C3.74976 6.15638 3.9031 6.18971 4.05643 6.25638L4.80976 5.51638C4.4431 5.30305 4.04976 5.17638 3.66976 5.14971C2.70309 5.08305 2.11643 5.67638 1.79643 5.99638L1.60976 6.18305C1.36976 6.41638 1.00309 6.76971 1.00309 6.77638C0.549762 7.20971 0.0697617 7.74971 0.109762 8.63638C0.169762 10.083 1.77643 11.723 3.23643 11.823C3.2831 11.8297 3.32976 11.8297 3.37643 11.8297C4.25643 11.8297 4.81643 11.2764 5.1231 10.9764L5.90976 10.2097C5.90976 10.2097 5.95643 10.1564 5.97643 10.1297C6.4031 9.70972 6.82976 9.18305 6.79643 8.34305C6.7831 7.93638 6.6431 7.51638 6.40976 7.11638Z" fill="#3E3F40"/>
                        <path d="M8.76976 0.176382C7.80309 0.103048 7.20976 0.709715 6.89643 1.02305L6.76976 1.14305C6.5431 1.36971 6.1031 1.80305 6.09643 1.80971C5.64976 2.24305 5.16976 2.77638 5.20976 3.66305C5.2231 4.03638 5.3431 4.42972 5.5431 4.80305L6.30309 4.06305C6.24309 3.91638 6.20976 3.76305 6.2031 3.62305C6.18976 3.18971 6.38976 2.91638 6.81643 2.50305C6.87643 2.44305 7.26309 2.06305 7.46976 1.86305L7.6031 1.73638C7.9631 1.37638 8.23643 1.16972 8.62976 1.16972C8.64976 1.16972 8.67643 1.17638 8.7031 1.17638C9.64976 1.24305 10.8564 2.47638 10.8964 3.41638C10.9098 3.84972 10.7164 4.11638 10.3098 4.50972C10.2831 4.53638 10.2631 4.56305 10.2431 4.58972L9.5231 5.28971C9.11643 5.68971 8.82976 5.87638 8.4031 5.85638C8.22976 5.84305 8.0431 5.78972 7.85643 5.70305L7.10976 6.43638C7.5031 6.67638 7.92976 6.82305 8.33643 6.85638C8.38309 6.85638 8.42976 6.86305 8.47643 6.86305C9.34976 6.86305 9.91643 6.30972 10.2231 6.00305L11.0098 5.23638C11.0098 5.23638 11.0564 5.18972 11.0764 5.16305C11.5031 4.73638 11.9298 4.20971 11.8898 3.37638C11.8298 1.92305 10.2298 0.283048 8.76976 0.176382Z" fill="#3E3F40"/>
                         <path d="M3.98303 8.47618C3.85316 8.47618 3.72296 8.42605 3.62496 8.32512C3.43223 8.12785 3.43616 7.81078 3.63409 7.61812L7.68096 3.67152C7.8789 3.47878 8.1953 3.48305 8.38796 3.68065C8.58063 3.87825 8.57676 4.19465 8.37883 4.38765L4.33196 8.33425C4.23496 8.42865 4.10896 8.47618 3.98303 8.47618Z" fill="#3E3F40"/>
                             </svg>
                      </div>
                      <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M10.8443 3.05956L10.3789 2.61229C9.41081 1.68262 8.78415 1.09669 8.24868 0.808224C7.74448 0.537424 7.18295 0.547157 6.70601 0.83429C6.43548 0.998357 6.24635 1.25549 6.12595 1.62462C6.03675 1.90849 5.98828 2.26396 5.96515 2.82256C3.28088 2.91562 0.0244141 3.57062 0.0244141 7.24896C0.0244141 9.10309 1.42808 10.8167 2.72721 11.3414C2.80501 11.3727 2.88675 11.3883 2.96748 11.3883C3.13021 11.3883 3.28975 11.3258 3.41021 11.2086C3.59055 11.0328 3.64981 10.7666 3.56128 10.5302C3.03135 9.11489 2.95548 8.15782 3.32888 7.60442C3.68175 7.08162 4.52681 6.79456 5.97148 6.71056C5.99461 7.28936 6.04795 7.71576 6.17881 8.05236C6.31908 8.41562 6.59741 8.69296 6.96235 8.83429C7.35721 8.98662 7.80835 8.96256 8.19541 8.76916C8.75528 8.49569 9.38975 7.88962 10.3849 6.93842L10.8527 6.48922C11.5213 5.84662 11.8895 5.49249 11.9607 4.97422C11.9799 4.84142 11.9799 4.70209 11.9614 4.57449C11.8898 4.05302 11.5237 3.70542 10.8443 3.05956ZM10.9703 4.83429C10.9459 5.01269 10.6331 5.31349 10.1578 5.76982L9.65848 6.24902C8.79815 7.07129 8.17668 7.66569 7.75221 7.87269C7.61388 7.94169 7.45401 7.95149 7.32288 7.90196C7.22135 7.86222 7.15001 7.79196 7.11095 7.69036C6.99895 7.40262 6.96868 6.87982 6.95761 6.18256C6.95535 6.04909 6.90001 5.92216 6.80395 5.82969C6.70761 5.73789 6.57475 5.68122 6.44521 5.69036C4.28441 5.74442 3.10475 6.14936 2.49988 7.04516C2.03861 7.72809 1.97255 8.64669 2.30455 9.89349C1.60728 9.26396 1.02428 8.24962 1.02428 7.24896C1.02428 4.86682 2.58615 3.86942 6.41295 3.81209C6.55648 3.82249 6.70528 3.77109 6.81108 3.66496C6.92275 3.55362 6.97321 3.39802 6.95335 3.24636L6.95728 3.06536C6.96835 2.68122 6.99181 2.20402 7.07808 1.92996C7.13995 1.74049 7.20441 1.70142 7.22328 1.68969C7.39615 1.58556 7.58235 1.58616 7.77535 1.68902C8.19688 1.91622 8.80561 2.48782 9.68615 3.33356L10.1709 3.79902C10.638 4.24302 10.9466 4.53602 10.971 4.71436C10.9765 4.75082 10.9765 4.79329 10.9703 4.83429Z" fill="#3E3F40"/>
                          </svg>
                      </div>
                      <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M10.667 5.33329H6.66699V1.33329C6.66699 0.964826 6.36879 0.666626 6.00033 0.666626C5.63186 0.666626 5.33366 0.964826 5.33366 1.33329V5.33329H1.33366C0.965192 5.33329 0.666992 5.63149 0.666992 5.99996C0.666992 6.36843 0.965192 6.66663 1.33366 6.66663H5.33366V10.6666C5.33366 11.0351 5.63186 11.3333 6.00033 11.3333C6.36879 11.3333 6.66699 11.0351 6.66699 10.6666V6.66663H10.667C11.0355 6.66663 11.3337 6.36843 11.3337 5.99996C11.3337 5.63149 11.0355 5.33329 10.667 5.33329Z" fill="#3E3F40"/>
                        </svg>
                      </div>
                      <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                          <path d="M4.92031 10.9562C4.64424 10.9562 4.42031 10.7323 4.42031 10.4562V4.74305C4.42031 4.46698 4.64424 4.24305 4.92031 4.24305C5.19638 4.24305 5.42031 4.46698 5.42031 4.74305V10.4562C5.42031 10.7323 5.19638 10.9562 4.92031 10.9562Z" fill="#3E3F40"/>
                       <path d="M7.08044 10.9562C6.80438 10.9562 6.58044 10.7323 6.58044 10.4562V4.74305C6.58044 4.46698 6.80438 4.24305 7.08044 4.24305C7.35651 4.24305 7.58044 4.46698 7.58044 4.74305V10.4562C7.58044 10.7323 7.35651 10.9562 7.08044 10.9562Z" fill="#3E3F40"/>
                       <path d="M11.447 1.97645H8.81351V1.56985C8.81351 0.864117 8.25751 0.289917 7.57391 0.289917H4.42024C3.73664 0.289917 3.18031 0.864117 3.18031 1.56985V1.97645H0.553711C0.277644 1.97645 0.0537109 2.20038 0.0537109 2.47645C0.0537109 2.75252 0.277644 2.97645 0.553711 2.97645H0.956578L1.46811 11.4055C1.54298 12.6979 2.61718 13.7102 3.91378 13.7102H8.07391C9.36951 13.7102 10.4496 12.6965 10.5329 11.4003L11.0448 2.97652H11.447C11.723 2.97652 11.947 2.75258 11.947 2.47652C11.947 2.20045 11.723 1.97645 11.447 1.97645ZM4.18038 1.56985C4.18038 1.41558 4.28811 1.28992 4.42031 1.28992H7.57398C7.70611 1.28992 7.81358 1.41558 7.81358 1.56985V1.97645H4.18044L4.18038 1.56985ZM9.53485 11.3378C9.48538 12.1073 8.84344 12.7102 8.07391 12.7102H3.91378C3.14651 12.7102 2.51044 12.1119 2.46618 11.3463L1.95831 2.97645H10.0424L9.53485 11.3378Z" fill="#3E3F40"/>
                           </svg>
                      </div>
                      

                    </div>
                    </div>
                    <div className={styles.videotablevalue}>Actions</div>
                  </div>

                  <div className={styles.videotabledescription}>
                    <div className={styles.videotablevalue}><input type="checkbox" name="" /></div>
                    <div className={styles.videotablevalue}>
                      <div className={styles.cliparea}>
                        <div className={styles.cliparealeft}>
                          <img src={clipvideo} onClick={openModalSmart} />
                        </div>
                        <div className={styles.cliparearight}>
                          <h3>Smart Episodes 01</h3>
                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                          <p>100 MB - 24 May 2024</p>
                        </div>
                      </div>
                    </div>
                    <div className={styles.videotablevalue}>
                    <Dropdown overlay={menuai}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="4" height="12" viewBox="0 0 4 12" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M2.00006 3.00867C2.82266 3.00867 3.49573 2.3356 3.49573 1.513C3.49573 0.690401 2.82266 0.017334 2.00006 0.017334C1.17746 0.017334 0.504395 0.690401 0.504395 1.513C0.504395 2.3356 1.17746 3.00867 2.00006 3.00867ZM2.00006 4.50433C1.17746 4.50433 0.504395 5.1774 0.504395 6C0.504395 6.8226 1.17746 7.49567 2.00006 7.49567C2.82266 7.49567 3.49573 6.8226 3.49573 6C3.49573 5.1774 2.82266 4.50433 2.00006 4.50433ZM0.504395 10.487C0.504395 9.6644 1.17746 8.99133 2.00006 8.99133C2.82266 8.99133 3.49573 9.6644 3.49573 10.487C3.49573 11.3096 2.82266 11.9827 2.00006 11.9827C1.17746 11.9827 0.504395 11.3096 0.504395 10.487Z" fill="#757676" />
                      </svg>
                    </Dropdown>
                    </div>
                  </div>
                </div> */}

                {/* <div className={styles.videotable}>
                  <div className={styles.videotabletitle}>
                    <div className={styles.videotablevalue}>
                    <input type="checkbox" name="" onChange={selectRecord}/>
                    </div>
                    <div className={styles.videotablevalue}>
                      Clip thumnail
                      <div className={styles.vdotableiconflex}>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M6.40976 7.11638L5.66309 7.84972C5.74309 8.03638 5.78976 8.21638 5.79643 8.38972C5.81643 8.81638 5.60976 9.09638 5.20976 9.48305C5.1831 9.50305 5.16309 9.52972 5.1431 9.55638L4.4231 10.2564C4.0231 10.6564 3.72976 10.8497 3.3031 10.8297C2.35643 10.763 1.1431 9.52972 1.10976 8.59638C1.08976 8.15638 1.2831 7.89638 1.71643 7.46971C1.76976 7.41638 2.09643 7.10305 2.3031 6.89638L2.5031 6.70305C2.8631 6.34305 3.1431 6.14305 3.52976 6.14305H3.6031C3.74976 6.15638 3.9031 6.18971 4.05643 6.25638L4.80976 5.51638C4.4431 5.30305 4.04976 5.17638 3.66976 5.14971C2.70309 5.08305 2.11643 5.67638 1.79643 5.99638L1.60976 6.18305C1.36976 6.41638 1.00309 6.76971 1.00309 6.77638C0.549762 7.20971 0.0697617 7.74971 0.109762 8.63638C0.169762 10.083 1.77643 11.723 3.23643 11.823C3.2831 11.8297 3.32976 11.8297 3.37643 11.8297C4.25643 11.8297 4.81643 11.2764 5.1231 10.9764L5.90976 10.2097C5.90976 10.2097 5.95643 10.1564 5.97643 10.1297C6.4031 9.70972 6.82976 9.18305 6.79643 8.34305C6.7831 7.93638 6.6431 7.51638 6.40976 7.11638Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M8.76976 0.176382C7.80309 0.103048 7.20976 0.709715 6.89643 1.02305L6.76976 1.14305C6.5431 1.36971 6.1031 1.80305 6.09643 1.80971C5.64976 2.24305 5.16976 2.77638 5.20976 3.66305C5.2231 4.03638 5.3431 4.42972 5.5431 4.80305L6.30309 4.06305C6.24309 3.91638 6.20976 3.76305 6.2031 3.62305C6.18976 3.18971 6.38976 2.91638 6.81643 2.50305C6.87643 2.44305 7.26309 2.06305 7.46976 1.86305L7.6031 1.73638C7.9631 1.37638 8.23643 1.16972 8.62976 1.16972C8.64976 1.16972 8.67643 1.17638 8.7031 1.17638C9.64976 1.24305 10.8564 2.47638 10.8964 3.41638C10.9098 3.84972 10.7164 4.11638 10.3098 4.50972C10.2831 4.53638 10.2631 4.56305 10.2431 4.58972L9.5231 5.28971C9.11643 5.68971 8.82976 5.87638 8.4031 5.85638C8.22976 5.84305 8.0431 5.78972 7.85643 5.70305L7.10976 6.43638C7.5031 6.67638 7.92976 6.82305 8.33643 6.85638C8.38309 6.85638 8.42976 6.86305 8.47643 6.86305C9.34976 6.86305 9.91643 6.30972 10.2231 6.00305L11.0098 5.23638C11.0098 5.23638 11.0564 5.18972 11.0764 5.16305C11.5031 4.73638 11.9298 4.20971 11.8898 3.37638C11.8298 1.92305 10.2298 0.283048 8.76976 0.176382Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M3.98303 8.47618C3.85316 8.47618 3.72296 8.42605 3.62496 8.32512C3.43223 8.12785 3.43616 7.81078 3.63409 7.61812L7.68096 3.67152C7.8789 3.47878 8.1953 3.48305 8.38796 3.68065C8.58063 3.87825 8.57676 4.19465 8.37883 4.38765L4.33196 8.33425C4.23496 8.42865 4.10896 8.47618 3.98303 8.47618Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M10.8443 3.05956L10.3789 2.61229C9.41081 1.68262 8.78415 1.09669 8.24868 0.808224C7.74448 0.537424 7.18295 0.547157 6.70601 0.83429C6.43548 0.998357 6.24635 1.25549 6.12595 1.62462C6.03675 1.90849 5.98828 2.26396 5.96515 2.82256C3.28088 2.91562 0.0244141 3.57062 0.0244141 7.24896C0.0244141 9.10309 1.42808 10.8167 2.72721 11.3414C2.80501 11.3727 2.88675 11.3883 2.96748 11.3883C3.13021 11.3883 3.28975 11.3258 3.41021 11.2086C3.59055 11.0328 3.64981 10.7666 3.56128 10.5302C3.03135 9.11489 2.95548 8.15782 3.32888 7.60442C3.68175 7.08162 4.52681 6.79456 5.97148 6.71056C5.99461 7.28936 6.04795 7.71576 6.17881 8.05236C6.31908 8.41562 6.59741 8.69296 6.96235 8.83429C7.35721 8.98662 7.80835 8.96256 8.19541 8.76916C8.75528 8.49569 9.38975 7.88962 10.3849 6.93842L10.8527 6.48922C11.5213 5.84662 11.8895 5.49249 11.9607 4.97422C11.9799 4.84142 11.9799 4.70209 11.9614 4.57449C11.8898 4.05302 11.5237 3.70542 10.8443 3.05956ZM10.9703 4.83429C10.9459 5.01269 10.6331 5.31349 10.1578 5.76982L9.65848 6.24902C8.79815 7.07129 8.17668 7.66569 7.75221 7.87269C7.61388 7.94169 7.45401 7.95149 7.32288 7.90196C7.22135 7.86222 7.15001 7.79196 7.11095 7.69036C6.99895 7.40262 6.96868 6.87982 6.95761 6.18256C6.95535 6.04909 6.90001 5.92216 6.80395 5.82969C6.70761 5.73789 6.57475 5.68122 6.44521 5.69036C4.28441 5.74442 3.10475 6.14936 2.49988 7.04516C2.03861 7.72809 1.97255 8.64669 2.30455 9.89349C1.60728 9.26396 1.02428 8.24962 1.02428 7.24896C1.02428 4.86682 2.58615 3.86942 6.41295 3.81209C6.55648 3.82249 6.70528 3.77109 6.81108 3.66496C6.92275 3.55362 6.97321 3.39802 6.95335 3.24636L6.95728 3.06536C6.96835 2.68122 6.99181 2.20402 7.07808 1.92996C7.13995 1.74049 7.20441 1.70142 7.22328 1.68969C7.39615 1.58556 7.58235 1.58616 7.77535 1.68902C8.19688 1.91622 8.80561 2.48782 9.68615 3.33356L10.1709 3.79902C10.638 4.24302 10.9466 4.53602 10.971 4.71436C10.9765 4.75082 10.9765 4.79329 10.9703 4.83429Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M10.667 5.33329H6.66699V1.33329C6.66699 0.964826 6.36879 0.666626 6.00033 0.666626C5.63186 0.666626 5.33366 0.964826 5.33366 1.33329V5.33329H1.33366C0.965192 5.33329 0.666992 5.63149 0.666992 5.99996C0.666992 6.36843 0.965192 6.66663 1.33366 6.66663H5.33366V10.6666C5.33366 11.0351 5.63186 11.3333 6.00033 11.3333C6.36879 11.3333 6.66699 11.0351 6.66699 10.6666V6.66663H10.667C11.0355 6.66663 11.3337 6.36843 11.3337 5.99996C11.3337 5.63149 11.0355 5.33329 10.667 5.33329Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="14"
                            viewBox="0 0 12 14"
                            fill="none"
                          >
                            <path
                              d="M4.92031 10.9562C4.64424 10.9562 4.42031 10.7323 4.42031 10.4562V4.74305C4.42031 4.46698 4.64424 4.24305 4.92031 4.24305C5.19638 4.24305 5.42031 4.46698 5.42031 4.74305V10.4562C5.42031 10.7323 5.19638 10.9562 4.92031 10.9562Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M7.08044 10.9562C6.80438 10.9562 6.58044 10.7323 6.58044 10.4562V4.74305C6.58044 4.46698 6.80438 4.24305 7.08044 4.24305C7.35651 4.24305 7.58044 4.46698 7.58044 4.74305V10.4562C7.58044 10.7323 7.35651 10.9562 7.08044 10.9562Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M11.447 1.97645H8.81351V1.56985C8.81351 0.864117 8.25751 0.289917 7.57391 0.289917H4.42024C3.73664 0.289917 3.18031 0.864117 3.18031 1.56985V1.97645H0.553711C0.277644 1.97645 0.0537109 2.20038 0.0537109 2.47645C0.0537109 2.75252 0.277644 2.97645 0.553711 2.97645H0.956578L1.46811 11.4055C1.54298 12.6979 2.61718 13.7102 3.91378 13.7102H8.07391C9.36951 13.7102 10.4496 12.6965 10.5329 11.4003L11.0448 2.97652H11.447C11.723 2.97652 11.947 2.75258 11.947 2.47652C11.947 2.20045 11.723 1.97645 11.447 1.97645ZM4.18038 1.56985C4.18038 1.41558 4.28811 1.28992 4.42031 1.28992H7.57398C7.70611 1.28992 7.81358 1.41558 7.81358 1.56985V1.97645H4.18044L4.18038 1.56985ZM9.53485 11.3378C9.48538 12.1073 8.84344 12.7102 8.07391 12.7102H3.91378C3.14651 12.7102 2.51044 12.1119 2.46618 11.3463L1.95831 2.97645H10.0424L9.53485 11.3378Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className={styles.videotablevalue}>Actions</div>
                  </div>

                  {clips &&
                    clips.length > 0 &&
                    clips.map((elem: any, index: any) => {
                      return (
                        <div
                          className={styles.videotabledescription}
                          key={index}
                        >
                          <div className={styles.videotablevalue}>
                          <input type="checkbox" name="" />
                          </div>
                          <div className={styles.videotablevalue}>
                            <div className={styles.cliparea}>
                              <div className={styles.cliparealeft}>
                              <img src={clipvideo} onClick={openModalSmart} />
                              </div>
                              <div className={styles.cliparearight}>
                                <h3>{elem.title}</h3>
                                <p>{elem.description}</p>
                                <p>{`${bytesToSize(elem.size)}`}</p>
                              </div>
                            </div>
                          </div>
                          <div className={styles.videotablevalue}>
                           <Dropdown overlay={menuai}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="4" height="12" viewBox="0 0 4 12" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M2.00006 3.00867C2.82266 3.00867 3.49573 2.3356 3.49573 1.513C3.49573 0.690401 2.82266 0.017334 2.00006 0.017334C1.17746 0.017334 0.504395 0.690401 0.504395 1.513C0.504395 2.3356 1.17746 3.00867 2.00006 3.00867ZM2.00006 4.50433C1.17746 4.50433 0.504395 5.1774 0.504395 6C0.504395 6.8226 1.17746 7.49567 2.00006 7.49567C2.82266 7.49567 3.49573 6.8226 3.49573 6C3.49573 5.1774 2.82266 4.50433 2.00006 4.50433ZM0.504395 10.487C0.504395 9.6644 1.17746 8.99133 2.00006 8.99133C2.82266 8.99133 3.49573 9.6644 3.49573 10.487C3.49573 11.3096 2.82266 11.9827 2.00006 11.9827C1.17746 11.9827 0.504395 11.3096 0.504395 10.487Z" fill="#757676" />
                           </svg>
                          </Dropdown>
                          </div>
                        </div>
                      );
                    })}
                </div> */}
              {/* </TabPane>  */}
              {/* <TabPane tab="Highlights" key="3">
                <div className={styles.videotable}>
                  <div className={styles.videotabletitle}>
                    <div className={styles.videotablevalue}>
                      <input type="checkbox" name="" />
                    </div>
                    <div className={styles.videotablevalue}>
                      Clip thumnail
                      <div className={styles.vdotableiconflex}>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M6.40976 7.11638L5.66309 7.84972C5.74309 8.03638 5.78976 8.21638 5.79643 8.38972C5.81643 8.81638 5.60976 9.09638 5.20976 9.48305C5.1831 9.50305 5.16309 9.52972 5.1431 9.55638L4.4231 10.2564C4.0231 10.6564 3.72976 10.8497 3.3031 10.8297C2.35643 10.763 1.1431 9.52972 1.10976 8.59638C1.08976 8.15638 1.2831 7.89638 1.71643 7.46971C1.76976 7.41638 2.09643 7.10305 2.3031 6.89638L2.5031 6.70305C2.8631 6.34305 3.1431 6.14305 3.52976 6.14305H3.6031C3.74976 6.15638 3.9031 6.18971 4.05643 6.25638L4.80976 5.51638C4.4431 5.30305 4.04976 5.17638 3.66976 5.14971C2.70309 5.08305 2.11643 5.67638 1.79643 5.99638L1.60976 6.18305C1.36976 6.41638 1.00309 6.76971 1.00309 6.77638C0.549762 7.20971 0.0697617 7.74971 0.109762 8.63638C0.169762 10.083 1.77643 11.723 3.23643 11.823C3.2831 11.8297 3.32976 11.8297 3.37643 11.8297C4.25643 11.8297 4.81643 11.2764 5.1231 10.9764L5.90976 10.2097C5.90976 10.2097 5.95643 10.1564 5.97643 10.1297C6.4031 9.70972 6.82976 9.18305 6.79643 8.34305C6.7831 7.93638 6.6431 7.51638 6.40976 7.11638Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M8.76976 0.176382C7.80309 0.103048 7.20976 0.709715 6.89643 1.02305L6.76976 1.14305C6.5431 1.36971 6.1031 1.80305 6.09643 1.80971C5.64976 2.24305 5.16976 2.77638 5.20976 3.66305C5.2231 4.03638 5.3431 4.42972 5.5431 4.80305L6.30309 4.06305C6.24309 3.91638 6.20976 3.76305 6.2031 3.62305C6.18976 3.18971 6.38976 2.91638 6.81643 2.50305C6.87643 2.44305 7.26309 2.06305 7.46976 1.86305L7.6031 1.73638C7.9631 1.37638 8.23643 1.16972 8.62976 1.16972C8.64976 1.16972 8.67643 1.17638 8.7031 1.17638C9.64976 1.24305 10.8564 2.47638 10.8964 3.41638C10.9098 3.84972 10.7164 4.11638 10.3098 4.50972C10.2831 4.53638 10.2631 4.56305 10.2431 4.58972L9.5231 5.28971C9.11643 5.68971 8.82976 5.87638 8.4031 5.85638C8.22976 5.84305 8.0431 5.78972 7.85643 5.70305L7.10976 6.43638C7.5031 6.67638 7.92976 6.82305 8.33643 6.85638C8.38309 6.85638 8.42976 6.86305 8.47643 6.86305C9.34976 6.86305 9.91643 6.30972 10.2231 6.00305L11.0098 5.23638C11.0098 5.23638 11.0564 5.18972 11.0764 5.16305C11.5031 4.73638 11.9298 4.20971 11.8898 3.37638C11.8298 1.92305 10.2298 0.283048 8.76976 0.176382Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M3.98303 8.47618C3.85316 8.47618 3.72296 8.42605 3.62496 8.32512C3.43223 8.12785 3.43616 7.81078 3.63409 7.61812L7.68096 3.67152C7.8789 3.47878 8.1953 3.48305 8.38796 3.68065C8.58063 3.87825 8.57676 4.19465 8.37883 4.38765L4.33196 8.33425C4.23496 8.42865 4.10896 8.47618 3.98303 8.47618Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M10.8443 3.05956L10.3789 2.61229C9.41081 1.68262 8.78415 1.09669 8.24868 0.808224C7.74448 0.537424 7.18295 0.547157 6.70601 0.83429C6.43548 0.998357 6.24635 1.25549 6.12595 1.62462C6.03675 1.90849 5.98828 2.26396 5.96515 2.82256C3.28088 2.91562 0.0244141 3.57062 0.0244141 7.24896C0.0244141 9.10309 1.42808 10.8167 2.72721 11.3414C2.80501 11.3727 2.88675 11.3883 2.96748 11.3883C3.13021 11.3883 3.28975 11.3258 3.41021 11.2086C3.59055 11.0328 3.64981 10.7666 3.56128 10.5302C3.03135 9.11489 2.95548 8.15782 3.32888 7.60442C3.68175 7.08162 4.52681 6.79456 5.97148 6.71056C5.99461 7.28936 6.04795 7.71576 6.17881 8.05236C6.31908 8.41562 6.59741 8.69296 6.96235 8.83429C7.35721 8.98662 7.80835 8.96256 8.19541 8.76916C8.75528 8.49569 9.38975 7.88962 10.3849 6.93842L10.8527 6.48922C11.5213 5.84662 11.8895 5.49249 11.9607 4.97422C11.9799 4.84142 11.9799 4.70209 11.9614 4.57449C11.8898 4.05302 11.5237 3.70542 10.8443 3.05956ZM10.9703 4.83429C10.9459 5.01269 10.6331 5.31349 10.1578 5.76982L9.65848 6.24902C8.79815 7.07129 8.17668 7.66569 7.75221 7.87269C7.61388 7.94169 7.45401 7.95149 7.32288 7.90196C7.22135 7.86222 7.15001 7.79196 7.11095 7.69036C6.99895 7.40262 6.96868 6.87982 6.95761 6.18256C6.95535 6.04909 6.90001 5.92216 6.80395 5.82969C6.70761 5.73789 6.57475 5.68122 6.44521 5.69036C4.28441 5.74442 3.10475 6.14936 2.49988 7.04516C2.03861 7.72809 1.97255 8.64669 2.30455 9.89349C1.60728 9.26396 1.02428 8.24962 1.02428 7.24896C1.02428 4.86682 2.58615 3.86942 6.41295 3.81209C6.55648 3.82249 6.70528 3.77109 6.81108 3.66496C6.92275 3.55362 6.97321 3.39802 6.95335 3.24636L6.95728 3.06536C6.96835 2.68122 6.99181 2.20402 7.07808 1.92996C7.13995 1.74049 7.20441 1.70142 7.22328 1.68969C7.39615 1.58556 7.58235 1.58616 7.77535 1.68902C8.19688 1.91622 8.80561 2.48782 9.68615 3.33356L10.1709 3.79902C10.638 4.24302 10.9466 4.53602 10.971 4.71436C10.9765 4.75082 10.9765 4.79329 10.9703 4.83429Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M10.667 5.33329H6.66699V1.33329C6.66699 0.964826 6.36879 0.666626 6.00033 0.666626C5.63186 0.666626 5.33366 0.964826 5.33366 1.33329V5.33329H1.33366C0.965192 5.33329 0.666992 5.63149 0.666992 5.99996C0.666992 6.36843 0.965192 6.66663 1.33366 6.66663H5.33366V10.6666C5.33366 11.0351 5.63186 11.3333 6.00033 11.3333C6.36879 11.3333 6.66699 11.0351 6.66699 10.6666V6.66663H10.667C11.0355 6.66663 11.3337 6.36843 11.3337 5.99996C11.3337 5.63149 11.0355 5.33329 10.667 5.33329Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="14"
                            viewBox="0 0 12 14"
                            fill="none"
                          >
                            <path
                              d="M4.92031 10.9562C4.64424 10.9562 4.42031 10.7323 4.42031 10.4562V4.74305C4.42031 4.46698 4.64424 4.24305 4.92031 4.24305C5.19638 4.24305 5.42031 4.46698 5.42031 4.74305V10.4562C5.42031 10.7323 5.19638 10.9562 4.92031 10.9562Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M7.08044 10.9562C6.80438 10.9562 6.58044 10.7323 6.58044 10.4562V4.74305C6.58044 4.46698 6.80438 4.24305 7.08044 4.24305C7.35651 4.24305 7.58044 4.46698 7.58044 4.74305V10.4562C7.58044 10.7323 7.35651 10.9562 7.08044 10.9562Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M11.447 1.97645H8.81351V1.56985C8.81351 0.864117 8.25751 0.289917 7.57391 0.289917H4.42024C3.73664 0.289917 3.18031 0.864117 3.18031 1.56985V1.97645H0.553711C0.277644 1.97645 0.0537109 2.20038 0.0537109 2.47645C0.0537109 2.75252 0.277644 2.97645 0.553711 2.97645H0.956578L1.46811 11.4055C1.54298 12.6979 2.61718 13.7102 3.91378 13.7102H8.07391C9.36951 13.7102 10.4496 12.6965 10.5329 11.4003L11.0448 2.97652H11.447C11.723 2.97652 11.947 2.75258 11.947 2.47652C11.947 2.20045 11.723 1.97645 11.447 1.97645ZM4.18038 1.56985C4.18038 1.41558 4.28811 1.28992 4.42031 1.28992H7.57398C7.70611 1.28992 7.81358 1.41558 7.81358 1.56985V1.97645H4.18044L4.18038 1.56985ZM9.53485 11.3378C9.48538 12.1073 8.84344 12.7102 8.07391 12.7102H3.91378C3.14651 12.7102 2.51044 12.1119 2.46618 11.3463L1.95831 2.97645H10.0424L9.53485 11.3378Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className={styles.videotablevalue}>Actions</div>
                  </div>

                  <div className={styles.videotabledescription}>
                    <div className={styles.videotablevalue}>
                      <input type="checkbox" name="" />
                    </div>
                    <div className={styles.videotablevalue}>
                      <div className={styles.cliparea}>
                        <div className={styles.cliparealeft}>
                          <img src={clipvideo} onClick={openModalHighlights} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </TabPane>  */}
              <TabPane tab="Clips" key="4" disabled={clipsPlaylistBtn}>
                <div className={styles.videotable}>
                  {/* <div className={styles.nodataemptyimgdiv}>
                     <img src={emptyimg}/>
                  </div> */}
                  <div className={styles.videotabletitle}>
                    <div className={styles.videotablevalue}>
                      <input
                        type="checkbox"
                        name=""
                        id="clipSelectAll"
                        onClick={selectAllClip}
                      />
                    </div>
                    <div className={styles.videotablevalue}>
                    <p className={styles.sortingiconelem}>  {selectedClips && selectedClips.length > 0 ?  `${selectedClips.length} Selected` : `Clip thumbnail`}
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
                        <path d="M1.49999 4.72589H6.50006C7.32672 4.72589 7.73339 3.71922 7.14006 3.14582L4.64012 0.725887C4.46012 0.552554 4.23012 0.46582 4.00006 0.46582C3.76999 0.46582 3.54012 0.552554 3.36006 0.725887L0.860058 3.14582C0.266724 3.71922 0.673324 4.72589 1.49999 4.72589ZM3.99999 1.49815L6.30146 3.72589H1.69852L3.99999 1.49815Z" fill="#757676"/>
                        <path d="M6.49999 6.27402H1.49992C0.673257 6.27402 0.266591 7.28069 0.859924 7.85409L3.35992 10.274C3.53992 10.4474 3.76992 10.5341 3.99992 10.5341C4.22992 10.5341 4.45999 10.4474 4.63999 10.274L7.13992 7.85409C7.73326 7.28069 7.32666 6.27402 6.49999 6.27402ZM4.00006 9.50175L1.69852 7.27402H6.30146L4.00006 9.50175Z" fill="#757676"/>
                       </svg>
                       </span>
                    </p>
                     { selectedClips.length > 0  &&
                      <div className={styles.vdotableiconflex}>
                        {/* <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M6.40976 7.11638L5.66309 7.84972C5.74309 8.03638 5.78976 8.21638 5.79643 8.38972C5.81643 8.81638 5.60976 9.09638 5.20976 9.48305C5.1831 9.50305 5.16309 9.52972 5.1431 9.55638L4.4231 10.2564C4.0231 10.6564 3.72976 10.8497 3.3031 10.8297C2.35643 10.763 1.1431 9.52972 1.10976 8.59638C1.08976 8.15638 1.2831 7.89638 1.71643 7.46971C1.76976 7.41638 2.09643 7.10305 2.3031 6.89638L2.5031 6.70305C2.8631 6.34305 3.1431 6.14305 3.52976 6.14305H3.6031C3.74976 6.15638 3.9031 6.18971 4.05643 6.25638L4.80976 5.51638C4.4431 5.30305 4.04976 5.17638 3.66976 5.14971C2.70309 5.08305 2.11643 5.67638 1.79643 5.99638L1.60976 6.18305C1.36976 6.41638 1.00309 6.76971 1.00309 6.77638C0.549762 7.20971 0.0697617 7.74971 0.109762 8.63638C0.169762 10.083 1.77643 11.723 3.23643 11.823C3.2831 11.8297 3.32976 11.8297 3.37643 11.8297C4.25643 11.8297 4.81643 11.2764 5.1231 10.9764L5.90976 10.2097C5.90976 10.2097 5.95643 10.1564 5.97643 10.1297C6.4031 9.70972 6.82976 9.18305 6.79643 8.34305C6.7831 7.93638 6.6431 7.51638 6.40976 7.11638Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M8.76976 0.176382C7.80309 0.103048 7.20976 0.709715 6.89643 1.02305L6.76976 1.14305C6.5431 1.36971 6.1031 1.80305 6.09643 1.80971C5.64976 2.24305 5.16976 2.77638 5.20976 3.66305C5.2231 4.03638 5.3431 4.42972 5.5431 4.80305L6.30309 4.06305C6.24309 3.91638 6.20976 3.76305 6.2031 3.62305C6.18976 3.18971 6.38976 2.91638 6.81643 2.50305C6.87643 2.44305 7.26309 2.06305 7.46976 1.86305L7.6031 1.73638C7.9631 1.37638 8.23643 1.16972 8.62976 1.16972C8.64976 1.16972 8.67643 1.17638 8.7031 1.17638C9.64976 1.24305 10.8564 2.47638 10.8964 3.41638C10.9098 3.84972 10.7164 4.11638 10.3098 4.50972C10.2831 4.53638 10.2631 4.56305 10.2431 4.58972L9.5231 5.28971C9.11643 5.68971 8.82976 5.87638 8.4031 5.85638C8.22976 5.84305 8.0431 5.78972 7.85643 5.70305L7.10976 6.43638C7.5031 6.67638 7.92976 6.82305 8.33643 6.85638C8.38309 6.85638 8.42976 6.86305 8.47643 6.86305C9.34976 6.86305 9.91643 6.30972 10.2231 6.00305L11.0098 5.23638C11.0098 5.23638 11.0564 5.18972 11.0764 5.16305C11.5031 4.73638 11.9298 4.20971 11.8898 3.37638C11.8298 1.92305 10.2298 0.283048 8.76976 0.176382Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M3.98303 8.47618C3.85316 8.47618 3.72296 8.42605 3.62496 8.32512C3.43223 8.12785 3.43616 7.81078 3.63409 7.61812L7.68096 3.67152C7.8789 3.47878 8.1953 3.48305 8.38796 3.68065C8.58063 3.87825 8.57676 4.19465 8.37883 4.38765L4.33196 8.33425C4.23496 8.42865 4.10896 8.47618 3.98303 8.47618Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div> */}
                        <div  onClick={openMultiShare}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M10.8443 3.05956L10.3789 2.61229C9.41081 1.68262 8.78415 1.09669 8.24868 0.808224C7.74448 0.537424 7.18295 0.547157 6.70601 0.83429C6.43548 0.998357 6.24635 1.25549 6.12595 1.62462C6.03675 1.90849 5.98828 2.26396 5.96515 2.82256C3.28088 2.91562 0.0244141 3.57062 0.0244141 7.24896C0.0244141 9.10309 1.42808 10.8167 2.72721 11.3414C2.80501 11.3727 2.88675 11.3883 2.96748 11.3883C3.13021 11.3883 3.28975 11.3258 3.41021 11.2086C3.59055 11.0328 3.64981 10.7666 3.56128 10.5302C3.03135 9.11489 2.95548 8.15782 3.32888 7.60442C3.68175 7.08162 4.52681 6.79456 5.97148 6.71056C5.99461 7.28936 6.04795 7.71576 6.17881 8.05236C6.31908 8.41562 6.59741 8.69296 6.96235 8.83429C7.35721 8.98662 7.80835 8.96256 8.19541 8.76916C8.75528 8.49569 9.38975 7.88962 10.3849 6.93842L10.8527 6.48922C11.5213 5.84662 11.8895 5.49249 11.9607 4.97422C11.9799 4.84142 11.9799 4.70209 11.9614 4.57449C11.8898 4.05302 11.5237 3.70542 10.8443 3.05956ZM10.9703 4.83429C10.9459 5.01269 10.6331 5.31349 10.1578 5.76982L9.65848 6.24902C8.79815 7.07129 8.17668 7.66569 7.75221 7.87269C7.61388 7.94169 7.45401 7.95149 7.32288 7.90196C7.22135 7.86222 7.15001 7.79196 7.11095 7.69036C6.99895 7.40262 6.96868 6.87982 6.95761 6.18256C6.95535 6.04909 6.90001 5.92216 6.80395 5.82969C6.70761 5.73789 6.57475 5.68122 6.44521 5.69036C4.28441 5.74442 3.10475 6.14936 2.49988 7.04516C2.03861 7.72809 1.97255 8.64669 2.30455 9.89349C1.60728 9.26396 1.02428 8.24962 1.02428 7.24896C1.02428 4.86682 2.58615 3.86942 6.41295 3.81209C6.55648 3.82249 6.70528 3.77109 6.81108 3.66496C6.92275 3.55362 6.97321 3.39802 6.95335 3.24636L6.95728 3.06536C6.96835 2.68122 6.99181 2.20402 7.07808 1.92996C7.13995 1.74049 7.20441 1.70142 7.22328 1.68969C7.39615 1.58556 7.58235 1.58616 7.77535 1.68902C8.19688 1.91622 8.80561 2.48782 9.68615 3.33356L10.1709 3.79902C10.638 4.24302 10.9466 4.53602 10.971 4.71436C10.9765 4.75082 10.9765 4.79329 10.9703 4.83429Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                        {/* <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M10.667 5.33329H6.66699V1.33329C6.66699 0.964826 6.36879 0.666626 6.00033 0.666626C5.63186 0.666626 5.33366 0.964826 5.33366 1.33329V5.33329H1.33366C0.965192 5.33329 0.666992 5.63149 0.666992 5.99996C0.666992 6.36843 0.965192 6.66663 1.33366 6.66663H5.33366V10.6666C5.33366 11.0351 5.63186 11.3333 6.00033 11.3333C6.36879 11.3333 6.66699 11.0351 6.66699 10.6666V6.66663H10.667C11.0355 6.66663 11.3337 6.36843 11.3337 5.99996C11.3337 5.63149 11.0355 5.33329 10.667 5.33329Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div> */}
                        <div onClick={openConfirmClipModal}>  
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="14"
                            viewBox="0 0 12 14"
                            fill="none"
                          >
                            <path
                              d="M4.92031 10.9562C4.64424 10.9562 4.42031 10.7323 4.42031 10.4562V4.74305C4.42031 4.46698 4.64424 4.24305 4.92031 4.24305C5.19638 4.24305 5.42031 4.46698 5.42031 4.74305V10.4562C5.42031 10.7323 5.19638 10.9562 4.92031 10.9562Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M7.08044 10.9562C6.80438 10.9562 6.58044 10.7323 6.58044 10.4562V4.74305C6.58044 4.46698 6.80438 4.24305 7.08044 4.24305C7.35651 4.24305 7.58044 4.46698 7.58044 4.74305V10.4562C7.58044 10.7323 7.35651 10.9562 7.08044 10.9562Z"
                              fill="#3E3F40"
                            />
                            <path
                              d="M11.447 1.97645H8.81351V1.56985C8.81351 0.864117 8.25751 0.289917 7.57391 0.289917H4.42024C3.73664 0.289917 3.18031 0.864117 3.18031 1.56985V1.97645H0.553711C0.277644 1.97645 0.0537109 2.20038 0.0537109 2.47645C0.0537109 2.75252 0.277644 2.97645 0.553711 2.97645H0.956578L1.46811 11.4055C1.54298 12.6979 2.61718 13.7102 3.91378 13.7102H8.07391C9.36951 13.7102 10.4496 12.6965 10.5329 11.4003L11.0448 2.97652H11.447C11.723 2.97652 11.947 2.75258 11.947 2.47652C11.947 2.20045 11.723 1.97645 11.447 1.97645ZM4.18038 1.56985C4.18038 1.41558 4.28811 1.28992 4.42031 1.28992H7.57398C7.70611 1.28992 7.81358 1.41558 7.81358 1.56985V1.97645H4.18044L4.18038 1.56985ZM9.53485 11.3378C9.48538 12.1073 8.84344 12.7102 8.07391 12.7102H3.91378C3.14651 12.7102 2.51044 12.1119 2.46618 11.3463L1.95831 2.97645H10.0424L9.53485 11.3378Z"
                              fill="#3E3F40"
                            />
                          </svg>
                        </div>
                      </div>
                     } 
                    </div>
                    <div className={styles.videotablevalue}>Actions</div>
                  </div>

                  {clips &&
                    clips.length > 0 &&
                    clips.map((elem: any, index: any) => {
                      return (
                        <div
                          className={styles.videotabledescription}
                          key={index}
                        >
                          <div className={styles.videotablevalue}>
                            <input
                              type="checkbox"
                              name=""
                              className="checkbox-item-clip"
                              onChange={(e: any) => selectClip(elem)}
                            />
                          </div>
                          <div className={styles.videotablevalue}  onClick={()=>openModalHighlights(elem,index)}>
                            <div className={styles.cliparea}>
                              <div className={styles.cliparealeft}>
                                <img src={elem.thumbnail_url} />
                              </div>
                              <div className={styles.cliparearight}>
                          <h3>{elem.title}</h3>
                          <p>{elem.description}</p>
                          
                          <p>{`${bytesToSize(elem.size)}`}
                          <span className={styles.dattendtimespann}>{formatDate(elem?.createdate)}</span>
                          </p>
                        </div>
                            </div>
                          </div>
                          <div className={styles.videotablevalue}>
                            <Dropdown overlay={menuai(elem)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="4"
                                height="12"
                                viewBox="0 0 4 12"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M2.00006 3.00867C2.82266 3.00867 3.49573 2.3356 3.49573 1.513C3.49573 0.690401 2.82266 0.017334 2.00006 0.017334C1.17746 0.017334 0.504395 0.690401 0.504395 1.513C0.504395 2.3356 1.17746 3.00867 2.00006 3.00867ZM2.00006 4.50433C1.17746 4.50433 0.504395 5.1774 0.504395 6C0.504395 6.8226 1.17746 7.49567 2.00006 7.49567C2.82266 7.49567 3.49573 6.8226 3.49573 6C3.49573 5.1774 2.82266 4.50433 2.00006 4.50433ZM0.504395 10.487C0.504395 9.6644 1.17746 8.99133 2.00006 8.99133C2.82266 8.99133 3.49573 9.6644 3.49573 10.487C3.49573 11.3096 2.82266 11.9827 2.00006 11.9827C1.17746 11.9827 0.504395 11.3096 0.504395 10.487Z"
                                  fill="#757676"
                                />
                              </svg>
                            </Dropdown>
                          </div>
                        </div>
                      );
                    })}
                    {
                    clips.length === 0 &&
                     (<div className={styles.nodataemptyimgdiv}>
                         <img src={emptyimg}/>
                     </div>)
                    }
                </div>
              </TabPane>
            </Tabs>
          </div>
          <div className={styles.mainarearights}></div>
        </div>
      </div>
    </>
  );
}
